import React, { Fragment, useState, Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css, ThemeProvider, createGlobalStyle, withTheme } from 'styled-components';
import { space as space$1, layout, position, flexbox, border, shadow, color, textAlign, flex, display } from 'styled-system';
import { transparentize, rgba } from 'polished';
import { createPortal } from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

var _baseRange = baseRange;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite;

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && _isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite_1(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite_1(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite_1(step);
    return _baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = _createRange();

var range_1 = range;

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(0.7);\n  }\n  100% {\n    transform: scale(1);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: 0 7px 14px 0 rgba(0, 0, 0, 0.08);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var colors = {
  black: '#000000',
  white: '#ffffff',
  primary: '#000552',
  secondary: '#9fabb8',
  greyMed: '#dfe0e7',
  greyLight: '#f0f1f4',
  greyDark: '#53535F',
  outline: '#C8C8C8',
  attention: '#fbad91',
  // peach
  alert: '#ff6f64',
  // red
  completed: '#b6dfec',
  // duck egg
  success: '#76d2a0',
  // green
  rating: '#f9d853' // yellow

};
var breakpoints = ['600px', '960px', '1280px', '1920px']; // Breakpoint aliases to use with space and layout props

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3]; // Mediaquery helpers to use with custom styled components

var mediaQueries = {
  sm: "@media screen and (min-width: ".concat(breakpoints.sm, ")"),
  md: "@media screen and (min-width: ".concat(breakpoints.md, ")"),
  lg: "@media screen and (min-width: ".concat(breakpoints.lg, ")"),
  xl: "@media screen and (min-width: ".concat(breakpoints.xl, ")")
};
var spaceUnit = 8;
var space = range_1(0, 64).map(function (n) {
  return spaceUnit * n;
});
var elevation = {
  "default": '0 7px 14px 0 rgba(0, 5, 82, 0.08)',
  top: '0 2px 14px 0 rgba(0, 5, 82, 0.08)',
  bottom: '0 12px 14px 0 rgba(0, 5, 82, 0.1)'
};
var borderRadius = 8;
var animations = {
  transitionAll: 'all 0.15s ease',
  transitionCurve: 'cubic-bezier(0.2, 0.7, 0.3, 1)',
  check: check,
  checkSmall: checkSmall
};
var boxShadow = function boxShadow() {
  return css(_templateObject());
};
var theme = {
  colors: colors,
  breakpoints: breakpoints,
  mediaQueries: mediaQueries,
  elevation: elevation,
  borderRadius: borderRadius,
  space: space,
  spaceUnit: spaceUnit,
  boxShadow: boxShadow,
  animations: animations
};
var check = keyframes(_templateObject2());
var checkSmall = keyframes(_templateObject3());

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  html {\n    -webkit-font-smoothing: antialiased;\n\t  -moz-osx-font-smoothing: grayscale;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes = {
  children: PropTypes.node
};
var defaultProps = {
  children: null
};

var Provider = function Provider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), children));
};

var GlobalStyle = createGlobalStyle(_templateObject$1());
Provider.propTypes = propTypes;
Provider.defaultProps = defaultProps;

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:after {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    z-index: 0;\n    width: ", ";\n    content: '';\n    border-bottom: 1px solid;\n    transform: translateX(-50%);\n    transition: 0.25s all ease;\n  }\n\n  &:hover:after {\n    width: ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  font: 600 24px 'Nunito Sans', sans-serif;\n  letter-spacing: 0;\n  line-height: 34px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  font: 900 0.75rem/1 'Nunito Sans', sans-serif;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font: 900 1.5625rem/1.12 'Nunito Sans', sans-serif;\n  letter-spacing: -0.33px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font: 900 2.1875rem/1 'Nunito Sans', sans-serif;\n  letter-spacing: -0.45px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font: 900 2.75rem/0.9772727 'Nunito Sans', sans-serif;\n  letter-spacing: -0.62px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 800;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font: 400 0.75rem/1.4 'Nunito Sans', sans-serif;\n  letter-spacing: -0.1px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  font: 400 0.875rem/1.4 'Nunito Sans', sans-serif;\n  letter-spacing: -0.2px;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  font: 400 1.25rem/1.4 'Nunito Sans', sans-serif;\n  letter-spacing: -0.2px;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  font: 400 1.063rem/1.4 'Nunito Sans', sans-serif;\n  letter-spacing: -0.2px;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var fontRegular = function fontRegular() {
  return css(_templateObject$2());
};
var fontLarge = function fontLarge() {
  return css(_templateObject2$1());
};
var fontSmall = function fontSmall() {
  return css(_templateObject3$1());
};
var fontSmaller = function fontSmaller() {
  return css(_templateObject4());
};
var fontBold = function fontBold() {
  return css(_templateObject5());
};
var heading1 = function heading1() {
  return css(_templateObject6());
};
var heading2 = function heading2() {
  return css(_templateObject7());
};
var heading3 = function heading3() {
  return css(_templateObject8());
};
var fontLabel = function fontLabel() {
  return css(_templateObject9());
};
var text = function text() {
  return css(_templateObject10(), function (props) {
    return props.size === 'small' ? fontSmall() : '';
  }, function (props) {
    return props.size === 'smaller' ? fontSmaller() : '';
  }, function (props) {
    return props.size === 'medium' ? fontRegular() : '';
  }, function (props) {
    return props.size === 'large' ? fontLarge() : '';
  }, function (props) {
    return props.bold ? fontBold() : '';
  });
};
var intro = function intro() {
  return css(_templateObject11());
};
var link = function link() {
  return css(_templateObject12(), text, function (props) {
    return props.underline ? '100%' : '0';
  }, function (props) {
    return props.underline ? '0' : '100%';
  });
};
var typography = {
  heading1: heading1,
  heading2: heading2,
  heading3: heading3,
  fontRegular: fontRegular,
  fontLarge: fontLarge,
  fontSmall: fontSmall,
  fontLabel: fontLabel,
  fontSmaller: fontSmaller,
  fontBold: fontBold,
  text: text,
  intro: intro,
  link: link
};

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var AnimateHeight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _classnames2 = _interopRequireDefault(classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

var PROPS_TO_OMIT = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'children', 'contentClassName', 'delay', 'duration', 'easing', 'height', 'onAnimationEnd', 'onAnimationStart'];

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  var requestAnimationFrameIDs = [];

  requestAnimationFrameIDs[0] = requestAnimationFrame(function () {
    requestAnimationFrameIDs[1] = requestAnimationFrame(function () {
      callback();
    });
  });

  return requestAnimationFrameIDs;
}

function cancelAnimationFrames(requestAnimationFrameIDs) {
  requestAnimationFrameIDs.forEach(function (id) {
    return cancelAnimationFrame(id);
  });
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function isPercentage(height) {
  // Percentage height
  return typeof height === 'string' && height.search('%') === height.length - 1 && isNumber(height.substr(0, height.length - 1));
}

function runCallback(callback, params) {
  if (callback && typeof callback === 'function') {
    callback(params);
  }
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    _this.animationFrameIDs = [];

    var height = 'auto';
    var overflow = 'visible';

    if (isNumber(props.height)) {
      // If value is string "0" make sure we convert it to number 0
      height = props.height < 0 || props.height === '0' ? 0 : props.height;
      overflow = 'hidden';
    } else if (isPercentage(props.height)) {
      // If value is string "0%" make sure we convert it to number 0
      height = props.height === '0%' ? 0 : props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props = this.props,
          delay = _props.delay,
          duration = _props.duration,
          height = _props.height,
          onAnimationEnd = _props.onAnimationEnd,
          onAnimationStart = _props.onAnimationStart;

      // Check if 'height' prop has changed

      if (this.contentElement && height !== prevProps.height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent(prevState.height);

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        // set total animation time
        var totalDuration = duration + delay;

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = prevState.height === 'auto';

        if (isNumber(height)) {
          // If value is string "0" make sure we convert it to number 0
          newHeight = height < 0 || height === '0' ? 0 : height;
          timeoutState.height = newHeight;
        } else if (isPercentage(height)) {
          // If value is string "0%" make sure we convert it to number 0
          newHeight = height === '0%' ? 0 : height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight; // TODO solve contentHeight = 0
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        // We are safe to call set state as it will not trigger infinite loop
        // because of the "height !== prevProps.height" check
        this.setState({ // eslint-disable-line react/no-did-update-set-state
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          cancelAnimationFrames(this.animationFrameIDs);
          this.animationFrameIDs = startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            runCallback(onAnimationStart, { newHeight: timeoutState.height });
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            runCallback(onAnimationEnd, { newHeight: timeoutState.height });
          }, totalDuration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          runCallback(onAnimationStart, { newHeight: newHeight });

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // If height is auto, don't hide the content
            // (case when element is empty, therefore height is 0)
            if (height !== 'auto') {
              // Hide content if height is 0 (to prevent tabbing into it)
              _this2.hideContent(newHeight); // TODO solve newHeight = 0
            }
            // Run a callback if it exists
            runCallback(onAnimationEnd, { newHeight: newHeight });
          }, totalDuration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrames(this.animationFrameIDs);

      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);

      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'showContent',
    value: function showContent(height) {
      if (height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props2 = this.props,
          animateOpacity = _props2.animateOpacity,
          applyInlineTransitions = _props2.applyInlineTransitions,
          children = _props2.children,
          className = _props2.className,
          contentClassName = _props2.contentClassName,
          delay = _props2.delay,
          duration = _props2.duration,
          easing = _props2.easing,
          id = _props2.id,
          style = _props2.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;


      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';

        // Include transition passed through styles
        if (style.transition) {
          componentStyle.transition = style.transition + ', ' + componentStyle.transition;
        }

        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
      }

      var contentStyle = {};

      if (animateOpacity) {
        contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;

        if (height === 0) {
          contentStyle.opacity = 0;
        }
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      // Check if user passed aria-hidden prop
      var hasAriaHiddenProp = typeof this.props['aria-hidden'] !== 'undefined';
      var ariaHidden = hasAriaHiddenProp ? this.props['aria-hidden'] : height === 0;

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(PROPS_TO_OMIT)), {
          'aria-hidden': ariaHidden,
          className: componentClasses,
          id: id,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            style: contentStyle,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

var heightPropType = function heightPropType(props, propName, componentName) {
  var value = props[propName];

  if (typeof value === 'number' && value >= 0 || isPercentage(value) || value === 'auto') {
    return null;
  }

  return new TypeError('value "' + value + '" of type "' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '" is invalid type for ' + propName + ' in ' + componentName + '. ' + 'It needs to be a positive number, string "auto" or percentage string (e.g. "15%").');
};

AnimateHeight.propTypes = {
  'aria-hidden': _propTypes2.default.bool,
  animateOpacity: _propTypes2.default.bool,
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  duration: _propTypes2.default.number,
  easing: _propTypes2.default.string,
  height: heightPropType,
  id: _propTypes2.default.string,
  onAnimationEnd: _propTypes2.default.func,
  onAnimationStart: _propTypes2.default.func,
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  animateOpacity: false,
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true,
  duration: 250,
  delay: 0,
  easing: 'ease',
  style: {}
};

exports.default = AnimateHeight;
});

var AnimateHeight = /*@__PURE__*/getDefaultExportFromCjs(AnimateHeight_1);

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n        stroke: ", ";\n      "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n        fill: ", ";\n      "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  * {\n    ", ";\n\n    ", ";\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$1 = {
  color: PropTypes.string,
  size: PropTypes.number,
  viewBox: PropTypes.string,
  title: PropTypes.string.isRequired
};
var defaultProps$1 = {
  color: 'secondary',
  size: 24,
  viewBox: '0 0 24 24'
};

var Icon = function Icon(_ref) {
  var size = _ref.size,
      title = _ref.title,
      viewBox = _ref.viewBox,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["size", "title", "viewBox", "children"]);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox,
    width: size,
    "aria-labelledby": "title",
    preserveAspectRatio: "xMidYMid meet"
  }, rest), /*#__PURE__*/React.createElement("title", {
    id: "title"
  }, title), children);
};

var Svg = styled.svg(_templateObject$3(), space$1);
var G = styled.g(_templateObject2$2(), function (props) {
  return props.fill && css(_templateObject3$2(), props.theme.colors[props.fill]);
}, function (props) {
  return props.stroke && css(_templateObject4$1(), props.theme.colors[props.stroke]);
});
Icon.propTypes = propTypes$1;
Icon.defaultProps = defaultProps$1;
Icon.G = G;

var propTypes$2 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$2 = {
  size: 24,
  color: 'secondary',
  title: 'Expand more icon'
};

function IconExpandMore(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  })));
}

IconExpandMore.propTypes = propTypes$2;
IconExpandMore.defaultProps = defaultProps$2;

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n      transform: rotate(180deg);\n      transform-origin: center;\n    "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  transition: ", ";\n\n  ", "\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  cursor: pointer;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$3 = {
  iconColor: PropTypes.string,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  onClick: PropTypes.func
};
var defaultProps$3 = {
  iconColor: 'primary',
  children: null,
  expanded: false,
  onClick: function onClick() {}
};

function AccordionTitle(_ref) {
  var iconColor = _ref.iconColor,
      children = _ref.children,
      expanded = _ref.expanded,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["iconColor", "children", "expanded", "onClick"]);

  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    expanded: expanded,
    onClick: onClick
  }, rest), /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement(ExpandIcon, {
    color: iconColor,
    expanded: expanded
  }));
}

var Wrapper = styled.div(_templateObject$4(), space$1);
var ExpandIcon = styled(IconExpandMore)(_templateObject2$3(), function (props) {
  return props.theme.animations.transitionAll;
}, function (props) {
  return props.expanded && css(_templateObject3$3());
});
AccordionTitle.propTypes = propTypes$3;
AccordionTitle.defaultProps = defaultProps$3;

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$4 = {
  children: PropTypes.node
};
var defaultProps$4 = {
  children: null
};

function AccordionContent(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Wrapper$1, rest, children);
}

var Wrapper$1 = styled.div(_templateObject$5(), space$1);
AccordionContent.propTypes = propTypes$4;
AccordionContent.defaultProps = defaultProps$4;

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$5 = {
  expanded: PropTypes.bool,
  iconColor: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
var defaultProps$5 = {
  expanded: false,
  iconColor: 'primary'
};

function Accordion(_ref) {
  var expanded = _ref.expanded,
      iconColor = _ref.iconColor,
      onChange = _ref.onChange,
      childrenProp = _ref.children,
      rest = _objectWithoutProperties(_ref, ["expanded", "iconColor", "onChange", "children"]);

  var _React$Children$toArr = React.Children.toArray(childrenProp),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      title = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  return /*#__PURE__*/React.createElement(Wrapper$2, rest, /*#__PURE__*/React.cloneElement(title, {
    expanded: expanded,
    iconColor: iconColor,
    onClick: function onClick() {
      return onChange(!expanded);
    }
  }), /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: 600,
    height: expanded ? 'auto' : 0
  }, children));
}

var Wrapper$2 = styled.div(_templateObject$6(), layout, space$1);
Accordion.Title = AccordionTitle;
Accordion.Content = AccordionContent;
Accordion.propTypes = propTypes$5;
Accordion.defaultProps = defaultProps$5;

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n      margin: 0;\n      padding: 24px 16px 16px 16px;\n\n      background-color: ", ";\n      box-shadow: ", ";\n      border-radius: 0 0 ", "px\n        ", "px;\n    "]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n      margin: 0;\n      padding: 16px 16px 24px 16px;\n\n      background-color: ", ";\n      box-shadow: ", ";\n      border-radius: ", "px ", "px\n        0 0;\n    "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n\n  border-radius: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$6 = {
  variant: PropTypes.oneOf(['default', 'bottomDrawer', 'topDrawer']),
  hasRoundedCorners: PropTypes.bool,
  hasBorder: PropTypes.bool
};
var defaultProps$6 = {
  variant: 'default',
  hasRoundedCorners: false,
  hasBorder: false
};
var Box = styled.div(_templateObject$7(), function (props) {
  return props.hasBorder ? "2px solid ".concat(props.theme.colors.greyMed) : 'none';
}, function (props) {
  return props.hasRoundedCorners ? "".concat(props.theme.borderRadius, "px") : 0;
}, function (props) {
  return props.variant === 'bottomDrawer' && css(_templateObject2$4(), props.theme.colors.white, props.theme.elevation.top, props.theme.borderRadius, props.theme.borderRadius);
}, function (props) {
  return props.variant === 'topDrawer' && css(_templateObject3$4(), props.theme.colors.white, props.theme.elevation["default"], props.theme.borderRadius, props.theme.borderRadius);
}, position, layout, flexbox, space$1, border, shadow, color, textAlign);
Box.propTypes = propTypes$6;
Box.defaultProps = defaultProps$6;

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n          box-shadow: ", ";\n        "]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  padding: ", "px;\n  border-radius: ", "px;\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$7 = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.node
};
var defaultProps$7 = {
  variant: 'primary',
  children: null
};
var Card = styled.div(_templateObject$8(), fontRegular, textAlign, layout, function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.variant === 'secondary' ? css(_templateObject2$5(), props.theme.colors.greyLight) : css(_templateObject3$5(), props.theme.colors.white, props.theme.elevation["default"]);
}, border, color, shadow, space$1, flex);
Card.propTypes = propTypes$7;
Card.defaultProps = defaultProps$7;

var js_cookie = createCommonjsModule(function (module, exports) {
(function (factory) {
	var registeredInModuleLoader;
	{
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
});

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n      bottom: 0;\n      left: calc(50% - ", "px);\n      position: absolute;\n      top: 0;\n    "]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n\n  ", ";\n\n  animation: ", " 400ms infinite linear;\n  border: solid 2px ", ";\n  border-radius: 50px;\n  border-top-color: ", ";\n  content: '';\n  height: ", "px;\n  margin: auto;\n  width: ", "px;\n  z-index: 2000;\n  ", ";\n  ", ";\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$8 = {
  color: PropTypes.string,
  size: PropTypes.number,
  isAbsolute: PropTypes.bool
};
var defaultProps$8 = {
  color: 'primary',
  size: 48,
  isAbsolute: false
};
var rotate360 = keyframes(_templateObject$9());
var Spinner = styled.div(_templateObject2$6(), display, rotate360, function (props) {
  return transparentize(0.9, colors[props.color]);
}, function (props) {
  return colors[props.color];
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.isAbsolute && css(_templateObject3$6(), props.size / 2);
}, space$1);
Spinner.propTypes = propTypes$8;
Spinner.defaultProps = defaultProps$8;

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      box-shadow: none;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n      border-radius: ", "px;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n\n      padding-top: 12px;\n      padding-bottom: 12px;\n      border-radius: ", "px;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n      border-radius: ", "px;\n    "]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  min-width: 96px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  text-align: center;\n  text-decoration: none;\n  white-space: nowrap;\n\n  border: 1px solid transparent;\n  box-shadow: ", ";\n\n  cursor: ", ";\n  user-select: none;\n  outline: none;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteral(["\n      &:focus,\n      &:hover {\n        box-shadow: ", ";\n        background-color: ", ";\n      }\n      &:active {\n        box-shadow: none;\n      }\n    "]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      border: 2px solid ", ";\n      box-shadow: none;\n    "]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 2px solid ", ";\n  box-shadow: ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n      &:focus,\n      &:hover {\n        box-shadow: ", ";\n        background-color: ", ";\n      }\n      &:active,\n        box-shadow: none;\n      }\n    "]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n      background: ", "\n      color: ", ";\n      box-shadow: none;\n    "]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n      &:focus,\n      &:hover {\n        box-shadow: ", ";\n        background-color: ", ";\n      }\n      &:active {\n        box-shadow: none;\n      }\n    "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      box-shadow: none;\n      cursor: not-allowed;\n    "]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  visibility: hidden;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$9 = {
  type: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'destructive']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node
};
var defaultProps$9 = {
  type: 'button',
  variant: 'primary',
  size: 'medium',
  loading: false,
  disabled: false,
  label: null,
  href: null,
  children: null
};

var mapVariantToColor = function mapVariantToColor(_ref) {
  var btnVar = _ref.variant;

  switch (btnVar) {
    case 'secondary':
      return 'primary';

    case 'destructive':
      return 'alert';

    default:
      return 'white';
  }
};

var Button = function Button(_ref2) {
  var type = _ref2.type,
      variant = _ref2.variant,
      size = _ref2.size,
      loading = _ref2.loading,
      label = _ref2.label,
      href = _ref2.href,
      children = _ref2.children,
      disabled = _ref2.disabled,
      rest = _objectWithoutProperties(_ref2, ["type", "variant", "size", "loading", "label", "href", "children", "disabled"]);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    as: href ? 'a' : 'button',
    type: href ? undefined : type,
    variant: variant,
    size: size,
    isLoading: loading,
    "aria-label": label,
    disabled: disabled,
    href: href
  }, rest), loading ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Invisible, null, children), /*#__PURE__*/React.createElement(Spinner, {
    color: mapVariantToColor({
      variant: variant
    }),
    isAbsolute: true,
    size: 20
  })) : children);
};

var Invisible = styled.span(_templateObject$a());

var primaryButton = function primaryButton(props) {
  return css(_templateObject2$7(), props.theme.colors.primary, props.theme.elevation["default"], props.theme.colors.white, props.disabled && css(_templateObject3$7(), rgba(props.theme.colors.primary, 0.11)), !props.disabled && !props.isLoading && css(_templateObject4$2(), props.theme.elevation.bottom, rgba(props.theme.colors.primary, 0.8)));
};

var secondaryButton = function secondaryButton(props) {
  return css(_templateObject5$1(), props.theme.colors.white, props.theme.elevation["default"], props.theme.colors.primary, props.disabled && css(_templateObject6$1(), props.theme.colors.white, rgba(props.theme.colors.primary, 0.11)), !props.disabled && !props.isLoading && css(_templateObject7$1(), props.theme.elevation.bottom, props.theme.colors.greyLight));
};

var destructiveButton = function destructiveButton(props) {
  return css(_templateObject8$1(), props.theme.colors.white, props.theme.colors.alert, props.theme.elevation["default"], props.theme.colors.alert, props.disabled && css(_templateObject9$1(), rgba(props.theme.colors.alert, 0.11), rgba(props.theme.colors.alert, 0.11)), !props.disabled && !props.isLoading && css(_templateObject10$1(), props.theme.elevation.bottom, props.theme.colors.greyLight));
};

var variant = function variant(props) {
  switch (props.variant) {
    case 'secondary':
      return secondaryButton;

    case 'destructive':
      return destructiveButton;

    case 'primary':
    default:
      return primaryButton;
  }
};

var StyledButton = styled.button(_templateObject11$1(), function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.elevation["default"];
}, function (props) {
  return props.disabled || props.isLoading ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.size === 'small' && css(_templateObject12$1(), fontSmall, fontBold, props.theme.space[1], props.theme.space[1], props.theme.space[3]);
}, function (props) {
  return props.size === 'medium' && css(_templateObject13(), fontRegular, fontBold, props.theme.space[3]);
}, function (props) {
  return props.size === 'large' && css(_templateObject14(), fontLarge, fontBold, props.theme.space[2], props.theme.space[2], props.theme.space[4]);
}, function (props) {
  return props.disabled && css(_templateObject15());
}, layout, space$1, variant);
Button.propTypes = propTypes$9;
Button.defaultProps = defaultProps$9;

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-transform: ", ";\n\n  a {\n    color: ", ";\n  }\n\n  b,\n  strong {\n    ", ";\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$a = {
  variant: PropTypes.oneOf(['body', 'intro']),
  size: PropTypes.oneOf(['smaller', 'small', 'medium', 'large']),
  color: PropTypes.string,
  transform: PropTypes.string,
  bold: PropTypes.bool
};
var defaultProps$a = {
  variant: 'body',
  size: 'medium',
  color: 'black',
  transform: 'none',
  bold: false
};
var Text = styled.p(_templateObject$b(), display, color, function (props) {
  return props.variant === 'intro' ? intro : text;
}, space$1, textAlign, function (props) {
  return props.transform;
}, function (props) {
  return props.theme.colors.primary;
}, fontBold);
Text.propTypes = propTypes$a;
Text.defaultProps = defaultProps$a;

/* prettier-ignore */
var ConsentMessages = {
  fi: {
    en: {
      infoText: 'We use cookies (and other similar technologies) to collect data to improve your experience on our site. By using our website, you\'re agreeing to the collection of data as described in our <a href="https://www.freska.fi/en/privacy-policy" target="_blank">privacy policy</a>.',
      buttonText: 'Close'
    },
    fi: {
      infoText: 'Käytämme evästeitä, jotta saat sivuiltamme parhaan mahdollisen kokemuksen. Jatkamalla hyväksyt, että keräämme tietoa <a href="https://www.freska.fi/tietosuojaseloste" target="_blank">tietosuojalausuntomme</a> mukaisesti.',
      buttonText: 'Sulje'
    }
  },
  no: {
    en: {
      infoText: 'We use cookies (and other similar technologies) to collect data to improve your experience on our site. By using our website, you\'re agreeing to the collection of data as described in our <a href="https://www.freska.no/en/privacy-policy" target="_blank">privacy policy</a>.',
      buttonText: 'Close'
    },
    nb: {
      infoText: 'Vi bruker cookies for å kunne tilby en mer personlig og brukervennlig tjeneste. Ved å bruke vår nettside, aksepterer du innsamling av data som beskrevet i vår <a href="https://www.freska.no/personvernerklaering" target="_blank">personvernerklæring</a>.',
      buttonText: 'Lukk'
    }
  },
  se: {
    en: {
      infoText: 'We use cookies (and other similar technologies) to collect data to improve your experience on our site. By using our website, you\'re agreeing to the collection of data as described in our <a href="https://www.freska.se/en/privacy-policy" target="_blank">privacy policy</a>.',
      buttonText: 'Close'
    },
    sv: {
      infoText: 'Vi använder cookies (och annan liknande teknik) för att samla in data i syfte att förbättra din upplevelse av vår webbplats. Genom att använda vår webbplats godkänner du insamlingen av data som beskrivs i vår <a href="https://www.freska.se/integritets-och-cookiespolicy" target="_blank">integritetspolicy</a>.',
      buttonText: 'Stänga'
    }
  }
};

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  a,\n  a:hover,\n  a:active,\n  a:focus,\n  a:visited {\n    color: ", ";\n  }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n      position: fixed;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      z-index: 99999999;\n    "]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  padding: ", ";\n  background-color: ", ";\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var cookieName = 'freska_cookie_consent';
var cookieExpires = 365;
var propTypes$b = {
  country: PropTypes.oneOf(['fi', 'no', 'se']),
  language: PropTypes.oneOf(['en', 'fi', 'nb', 'sv']),
  fixed: PropTypes.bool,
  hideOnClose: PropTypes.bool,
  onClose: PropTypes.func
};
var defaultProps$b = {
  country: 'fi',
  language: 'en',
  fixed: true,
  hideOnClose: true,
  onClose: function onClose() {}
};

function topDomain() {
  return window.location.hostname.replace(/^[a-zA-Z0-9]*\./, '.');
}

function Consent(_ref) {
  var country = _ref.country,
      language = _ref.language,
      fixed = _ref.fixed,
      hideOnClose = _ref.hideOnClose,
      onClose = _ref.onClose;

  var _useState = useState(hideOnClose ? !js_cookie.get(cookieName) : true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  function close() {
    js_cookie.set(cookieName, true, {
      expires: cookieExpires,
      domain: topDomain()
    });

    if (hideOnClose) {
      setVisible(false);
    }

    onClose();
  }

  return visible ? /*#__PURE__*/React.createElement(Wrapper$3, {
    fixed: fixed
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: ['column', 'row'],
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    pr: [0, 1],
    pb: [1, 0]
  }, /*#__PURE__*/React.createElement(InfoText, {
    as: "p",
    variant: "body",
    color: "white",
    mb: 0,
    dangerouslySetInnerHTML: {
      __html: ConsentMessages[country][language].infoText
    }
  })), /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "primary",
    size: "medium",
    onClick: close
  }, ConsentMessages[country][language].buttonText)))) : null;
}

var Wrapper$3 = styled.div(_templateObject$c(), function (props) {
  return props.fixed && css(_templateObject2$8());
}, function (props) {
  return "".concat(props.theme.spaceUnit * 3, "px ").concat(props.theme.spaceUnit * 2, "px");
}, function (props) {
  return props.theme.colors.secondary;
});
var InfoText = styled(Text)(_templateObject3$8(), function (props) {
  return props.theme.colors.greyMed;
});
Consent.propTypes = propTypes$b;
Consent.defaultProps = defaultProps$b;
Consent.cookieName = cookieName;
Consent.cookieExpires = cookieExpires;

var propTypes$c = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$c = {
  size: 24,
  color: 'secondary',
  title: 'Close icon'
};

function IconClose(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })));
}

IconClose.propTypes = propTypes$c;
IconClose.defaultProps = defaultProps$c;

var propTypes$d = {
  children: PropTypes.node
};
var defaultProps$d = {
  children: null
};

function ModalContent(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "section"
  }, rest), children);
}

ModalContent.propTypes = propTypes$d;
ModalContent.defaultProps = defaultProps$d;

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 0;\n      height: 0;\n      opacity: 0;\n    "]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$e = {
  hidden: PropTypes.bool,
  children: PropTypes.node
};
var defaultProps$e = {
  hidden: false,
  children: null
};

function ModalDescription(_ref) {
  var hidden = _ref.hidden,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["hidden", "children"]);

  return /*#__PURE__*/React.createElement(Wrapper$4, _extends({
    id: "dialog-desc",
    as: "p",
    hidden: hidden
  }, rest), children);
}

var Wrapper$4 = styled(Text)(_templateObject$d(), space$1, function (props) {
  return props.hidden && css(_templateObject2$9());
});
ModalDescription.propTypes = propTypes$e;
ModalDescription.defaultProps = defaultProps$e;

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  ", ";  \n  ", ";\n\n  ", "\n  ", "\n  ", "\n\n  ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$f = {
  level: PropTypes.oneOf([1, 2, 3]),
  color: PropTypes.string
};
var defaultProps$f = {
  level: 1,
  color: 'black'
};

var HeadingBase = function HeadingBase(_ref) {
  var level = _ref.level,
      rest = _objectWithoutProperties(_ref, ["level"]);

  var Component = "h".concat(level);
  return /*#__PURE__*/React.createElement(Component, rest);
};

var Heading = styled(HeadingBase)(_templateObject$e(), color, textAlign, function (_ref2) {
  var level = _ref2.level;
  return level === 1 && heading1();
}, function (_ref3) {
  var level = _ref3.level;
  return level === 2 && heading2();
}, function (_ref4) {
  var level = _ref4.level;
  return level === 3 && heading3();
}, space$1);
HeadingBase.propTypes = propTypes$f;
HeadingBase.defaultProps = propTypes$f;
Heading.propTypes = propTypes$f;
Heading.defaultProps = defaultProps$f;

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n      height: 0;\n      opacity: 0;\n    "]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n\n  ", ";\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$g = {
  hidden: PropTypes.bool,
  children: PropTypes.node
};
var defaultProps$g = {
  hidden: false,
  children: null
};

function ModalTitle(_ref) {
  var hidden = _ref.hidden,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["hidden", "children"]);

  return /*#__PURE__*/React.createElement(Wrapper$5, _extends({
    id: "dialog-title",
    level: 2,
    hidden: hidden
  }, rest), children);
}

var Wrapper$5 = styled(Heading)(_templateObject$f(), function (props) {
  return props.hidden && css(_templateObject2$a());
});
ModalTitle.propTypes = propTypes$g;
ModalTitle.defaultProps = defaultProps$g;

function _templateObject9$2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral(["\n      box-shadow: ", ";\n    "]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 100000;\n\n  background: ", ";\n\n  ", ";\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n      max-height: unset;\n      height: 100vh;\n      width: 100vw;\n      margin: 0;\n      border-radius: 0;\n    "]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n      max-width: ", "px;\n    "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n      max-width: ", "px;\n    "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n      max-width: ", "px;\n    "]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  margin: ", "px;\n  max-height: calc(100vh - calc(2 * ", "px));\n  width: 100%;\n\n  background: ", ";\n  border-radius: ", "px;\n  overflow-y: auto;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  align-content: center;\n  background: ", ";\n  display: flex;\n  height: 100vh;\n  left: 0;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 99999;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$h = {
  size: PropTypes.oneOf(['small', 'medium', 'large', 'fullscreen']),
  hideTitle: PropTypes.bool,
  hideDescription: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  fixedHeaderContent: PropTypes.node,
  mountId: PropTypes.string
};
var defaultProps$h = {
  size: 'medium',
  hideTitle: false,
  hideDescription: false,
  children: null,
  fixedHeaderContent: null,
  mountId: 'root'
};

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (e) {
      var onClose = _this.props.onClose;

      if (e.target === _this.mask.current) {
        onClose();
      }
    });

    var mountId = _this.props.mountId;
    _this.mask = /*#__PURE__*/React.createRef();
    _this.dialog = /*#__PURE__*/React.createRef();
    _this.mount = document.getElementById(mountId);
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.style.overflow = 'hidden';

      if (document.activeElement instanceof HTMLInputElement || document.activeElement instanceof HTMLButtonElement) {
        this.focusedElementBeforeDialogOpened = document.activeElement;
      }

      this.mask.current.addEventListener('click', this.closeModal);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.style.overflow = 'auto';

      if (this.focusedElementBeforeDialogOpened) {
        this.focusedElementBeforeDialogOpened.focus();
      }

      this.mask.current.removeEventListener('click', this.closeModal);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          hideTitle = _this$props.hideTitle,
          hideDescription = _this$props.hideDescription,
          onClose = _this$props.onClose,
          childrenProp = _this$props.children,
          fixedHeaderContent = _this$props.fixedHeaderContent;

      var _React$Children$toArr = React.Children.toArray(childrenProp),
          _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 3),
          title = _React$Children$toArr2[0],
          description = _React$Children$toArr2[1],
          content = _React$Children$toArr2[2];

      if (!title || !description) {
        throw new Error('Title or Description children are missing');
      }

      return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(DialogMask, {
        ref: this.mask
      }, /*#__PURE__*/React.createElement(Wrapper$6, {
        size: size,
        ref: this.dialog
      }, /*#__PURE__*/React.createElement(Header, {
        fixedHeaderContent: fixedHeaderContent,
        size: size,
        pt: 3,
        pb: hideTitle ? 0 : 2,
        px: 3
      }, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        justifyContent: hideTitle ? 'flex-end' : 'space-between',
        alignItems: "center",
        width: "100%",
        mb: fixedHeaderContent ? 2 : 0
      }, /*#__PURE__*/React.cloneElement(title, {
        hidden: !!hideTitle
      }), /*#__PURE__*/React.createElement(StyledIcon, {
        id: "close-btn",
        onClick: onClose,
        type: "button",
        color: "secondary",
        size: 24
      })), fixedHeaderContent && /*#__PURE__*/React.createElement(Box, null, fixedHeaderContent)), /*#__PURE__*/React.createElement(Box, {
        pt: fixedHeaderContent ? 3 : 0,
        pb: hideTitle ? 6 : 3,
        px: 3
      }, /*#__PURE__*/React.cloneElement(description, {
        hidden: !!hideDescription,
        mb: content ? 3 : 0
      }), content && /*#__PURE__*/React.cloneElement(content)))), this.mount);
    }
  }]);

  return Modal;
}(Component);

var DialogMask = styled.div(_templateObject$g(), function (props) {
  return transparentize(0.3, props.theme.colors.black);
});
var Wrapper$6 = styled.section.attrs({
  role: 'dialog',
  'aria-hidden': false,
  'aria-labelledby': 'dialog-title',
  'aria-describedby': 'dialog-desc'
})(_templateObject2$b(), function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.size === 'small' && css(_templateObject3$9(), props.theme.spaceUnit * 44);
}, function (props) {
  return props.size === 'medium' && css(_templateObject4$3(), props.theme.spaceUnit * 64);
}, function (props) {
  return props.size === 'large' && css(_templateObject5$2(), props.theme.spaceUnit * 96);
}, function (props) {
  return props.size === 'fullscreen' && css(_templateObject6$2());
});
var Header = styled(Box)(_templateObject7$2(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.size === 'fullscreen' && css(_templateObject8$2(), props.theme.elevation.bottom);
});
var StyledIcon = styled(IconClose)(_templateObject9$2());
Modal.Title = ModalTitle;
Modal.Description = ModalDescription;
Modal.Content = ModalContent;
Modal.propTypes = propTypes$h;
Modal.defaultProps = defaultProps$h;
var Modal$1 = withTheme(Modal);

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  display: inline-flex;\n  height: 26px;\n  justify-content: center;\n  min-width: 64px;\n  padding: 5px 8px;\n  vertical-align: middle;\n\n  ", ";\n  color: ", ";\n\n  background: ", ";\n  border: 2px solid\n    ", ";\n  border-radius: ", ";\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$i = {
  children: PropTypes.node.isRequired,
  isOutlined: PropTypes.bool,
  isFullyRounded: PropTypes.bool,
  color: PropTypes.string
};
var defaultProps$i = {
  isOutlined: false,
  isFullyRounded: false,
  color: 'secondary'
};

var Tag = function Tag(_ref) {
  var children = _ref.children,
      isOutlined = _ref.isOutlined,
      isFullyRounded = _ref.isFullyRounded,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["children", "isOutlined", "isFullyRounded", "color"]);

  return /*#__PURE__*/React.createElement(Wrapper$7, rest, /*#__PURE__*/React.createElement(StyledTag, {
    color: color,
    isFullyRounded: isFullyRounded,
    isOutlined: isOutlined
  }, children));
};

var StyledTag = styled.div(_templateObject$h(), fontLabel(), function (props) {
  return props.isOutlined ? props.theme.colors[props.color] : props.theme.colors.white;
}, function (props) {
  return props.isOutlined ? 'transparent' : props.theme.colors[props.color];
}, function (props) {
  return props.isOutlined ? props.theme.colors[props.color] : 'transparent';
}, function (props) {
  return props.isFullyRounded ? '13px' : '4px';
});
var Wrapper$7 = styled.div(_templateObject2$c(), space$1);
Tag.propTypes = propTypes$i;
Tag.defaultProps = defaultProps$i;

function _templateObject3$a() {
  var data = _taggedTemplateLiteral(["\n      &:focus,\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  line-height: 0;\n\n  background-color: ", ";\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  outline: none;\n  padding: ", "px;\n\n  path:first-child {\n    fill: ", ";\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$j = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium'])
};
var defaultProps$j = {
  size: 'small'
};

function IconButton(_ref) {
  var children = _ref.children,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["children", "size"]);

  return /*#__PURE__*/React.createElement(Button$1, _extends({
    size: size
  }, rest), children);
}

var Button$1 = styled.button.attrs(function () {
  return {
    type: 'button'
  };
})(_templateObject$i(), space$1, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.size === 'medium' ? props.theme.space[1] : 5;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.disabled && css(_templateObject2$d(), rgba(props.theme.colors.primary, 0.11));
}, function (props) {
  return !props.disabled && css(_templateObject3$a(), rgba(props.theme.colors.primary, 0.8), props.theme.colors.primary);
});
IconButton.propTypes = propTypes$j;
IconButton.defaultProps = defaultProps$j;

var propTypes$k = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$k = {
  size: 24,
  color: 'secondary',
  title: 'Check'
};

function IconCheck(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z"
  })));
}

IconCheck.propTypes = propTypes$k;
IconCheck.defaultProps = defaultProps$k;

function _templateObject11$2() {
  var data = _taggedTemplateLiteral(["\n      &::after {\n        display: inline-block;\n        color: ", ";\n        content: '*';\n        margin-left: 0.3em;\n      }\n    "]);

  _templateObject11$2 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$2() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$3() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n\n  cursor: inherit;\n  opacity: 0;\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteral(["\n      opacity: 0;\n    "]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  opacity: 1;\n\n  ", "\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      border-color: ", ";\n    "]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: inherit;\n  justify-content: inherit;\n\n  background: ", ";\n  border: 2px solid\n    ", ";\n\n  transition: ", ";\n\n  ", "\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  cursor: pointer;\n\n  ", "\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$l = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool
};
var defaultProps$l = {
  disabled: false,
  required: false,
  checked: false
};

function Checkbox(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      required = _ref.required,
      rest = _objectWithoutProperties(_ref, ["id", "name", "label", "checked", "disabled", "onChange", "required"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "block"
  }, rest), /*#__PURE__*/React.createElement(Wrapper$8, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Check, {
    checked: checked,
    disabled: disabled,
    mr: 1
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    color: disabled ? 'greyLight' : 'white',
    checked: checked,
    size: 20
  })), /*#__PURE__*/React.createElement(Input, _extends({
    id: id,
    name: name,
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    required: required,
    onChange: onChange
  }, rest)), /*#__PURE__*/React.createElement(Label, {
    checked: checked,
    disabled: disabled,
    required: required,
    mb: 0
  }, label)));
}

var Wrapper$8 = styled.label(_templateObject$j(), function (props) {
  return props.disabled && css(_templateObject2$e());
});
var Check = styled(Box)(_templateObject3$b(), function (props) {
  return props.theme.colors[props.checked ? 'primary' : 'white'];
}, function (props) {
  return props.theme.colors[props.checked ? 'primary' : 'greyMed'];
}, function (props) {
  return props.theme.animations.transitionAll;
}, function (props) {
  return props.disabled && css(_templateObject4$4(), props.checked ? props.theme.colors.greyMed : props.theme.colors.greyLight, props.theme.colors.greyMed);
});
var CheckIcon = styled(IconCheck)(_templateObject5$3(), function (props) {
  return !props.checked && css(_templateObject6$3());
});
var Input = styled.input(_templateObject7$3());
var Label = styled(Text)(_templateObject8$3(), function (props) {
  return props.checked && css(_templateObject9$3(), props.theme.colors.primary);
}, function (props) {
  return props.disabled && css(_templateObject10$2(), props.theme.colors.secondary);
}, function (props) {
  return props.required && css(_templateObject11$2(), props.theme.colors.alert);
});
Checkbox.propTypes = propTypes$l;
Checkbox.defaultProps = defaultProps$l;

function _templateObject6$4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-align: center;\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        background-color: ", ";\n      }\n    "]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: ", ";\n  height: 100%;\n  fill: ", ";\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: ", "px;\n  transition: ", ";\n  outline-color: ", ";\n  pointer-events: ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  flex: 1 0 0;\n  margin-right: ", "px;\n  margin-bottom: ", "px;\n\n  ", "\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$m = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelTitle: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  stacked: PropTypes.bool,
  labelDescription: PropTypes.string,
  disabled: PropTypes.bool
};
var defaultProps$m = {
  checked: false,
  stacked: false,
  labelDescription: null,
  disabled: false
};

var RadioBox = function RadioBox(_ref) {
  var id = _ref.id,
      name = _ref.name,
      checked = _ref.checked,
      onChange = _ref.onChange,
      stacked = _ref.stacked,
      labelTitle = _ref.labelTitle,
      labelDescription = _ref.labelDescription,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["id", "name", "checked", "onChange", "stacked", "labelTitle", "labelDescription", "disabled"]);

  return /*#__PURE__*/React.createElement(Wrapper$9, _extends({
    stacked: stacked,
    disabled: disabled
  }, rest), /*#__PURE__*/React.createElement(Input$1, {
    type: "radio",
    id: id,
    name: name,
    onChange: onChange,
    checked: checked,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: id,
    checked: checked,
    onKeyPress: onChange,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Text, {
    color: disabled ? 'secondary' : 'primary',
    bold: checked
  }, labelTitle)), labelDescription && /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "secondary"
  }, labelDescription))));
};

var Wrapper$9 = styled.div(_templateObject$k(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.stacked ? 0 : props.theme.spaceUnit;
}, function (props) {
  return props.stacked ? props.theme.spaceUnit : 0;
}, space$1);
var Input$1 = styled.input(_templateObject2$f());
var Label$1 = styled.label.attrs({
  tabIndex: 0
})(_templateObject3$c(), function (props) {
  return props.theme.boxShadow;
}, function (props) {
  return "".concat(props.theme.spaceUnit * 3, "px ").concat(props.theme.spaceUnit, "px");
}, function (props) {
  return props.theme.colors.greyDark;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.greyMed;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.animations.transitionAll;
}, function (props) {
  return props.theme.colors.outline;
}, function (props) {
  return props.disabled ? 'none' : 'default';
}, function (props) {
  return props.checked && css(_templateObject4$5(), props.theme.colors.primary);
}, function (props) {
  return !props.checked && css(_templateObject5$4(), props.theme.colors.greyLight);
});
var Content = styled.div(_templateObject6$4());
RadioBox.propTypes = propTypes$m;
RadioBox.defaultProps = defaultProps$m;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

var _castSlice = castSlice;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && _baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

var _charsEndIndex = charsEndIndex;

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && _baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

var _charsStartIndex = charsStartIndex;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']',
    rsCombo = '[' + rsComboRange$1 + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange$1 + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange$1 + ']?',
    rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

var _stringToArray = stringToArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString_1(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim$1, '');
  }
  if (!string || !(chars = _baseToString(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      chrSymbols = _stringToArray(chars),
      start = _charsStartIndex(strSymbols, chrSymbols),
      end = _charsEndIndex(strSymbols, chrSymbols) + 1;

  return _castSlice(strSymbols, start, end).join('');
}

var trim_1 = trim;

function _templateObject12$2() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject12$2 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  margin-top: 4px;\n\n  color: ", ";\n  text-align: ", ";\n\n  ", ";\n"]);

  _templateObject11$3 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$3() {
  var data = _taggedTemplateLiteral(["\n      -moz-appearance: textfield;\n\n      ::-webkit-inner-spin-button,\n      ::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n    "]);

  _templateObject10$3 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$4() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      -webkit-text-fill-color: ", ";\n\n      background-color: ", ";\n      border: 1px solid\n        ", ";\n      cursor: not-allowed;\n\n      ::placeholder {\n        color: ", ";\n      }\n\n      ~ ", " {\n        color: ", ";\n        display: none;\n      }\n    "]);

  _templateObject9$4 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteral(["\n      :focus {\n        &::placeholder {\n          opacity: 1;\n          color: ", ";\n        }\n      }\n    "]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$4() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      color: ", ";\n\n      ~ ", " {\n        color: ", ";\n      }\n    "]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: 100%;\n  height: ", "px;\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  margin: auto;\n  box-sizing: border-box;\n\n  color: ", ";\n\n  background-color: ", ";\n  appearance: none;\n  cursor: text;\n  outline: none;\n  border-radius: ", "px;\n  border: 1px solid\n    ", ";\n\n  &::placeholder {\n    color: ", ";\n    opacity: ", ";\n    transition: all 200ms;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      transform: translate(0, -10px);\n    "]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  position: absolute;\n  top: 15px;\n  left: ", "px;\n\n  color: ", ";\n  transition: all 200ms;\n  cursor: text;\n\n  ", ";\n\n  ", "\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n      &:focus-within label {\n        ", ";\n        transform: translate(0, -10px);\n      }\n    "]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  position: relative;\n\n  ", ";\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$n = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  shrink: PropTypes.bool,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'borderless']),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  extraText: PropTypes.string,
  extraTextAlign: PropTypes.oneOf(['left', 'right']),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  labelAlign: PropTypes.oneOf(['left', 'center', 'right']),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
var defaultProps$n = {
  label: null,
  shrink: false,
  type: 'text',
  variant: 'standard',
  placeholder: null,
  value: undefined,
  extraText: null,
  disabled: false,
  error: false,
  required: false,
  name: null,
  labelAlign: 'left',
  extraTextAlign: 'left',
  onChange: null,
  onFocus: null,
  onBlur: null
};
var Input$2 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      shrink = _ref.shrink,
      variant = _ref.variant,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      value = _ref.value,
      name = _ref.name,
      type = _ref.type,
      error = _ref.error,
      extraText = _ref.extraText,
      placeholder = _ref.placeholder,
      extraTextAlign = _ref.extraTextAlign,
      labelAlign = _ref.labelAlign,
      required = _ref.required,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["id", "label", "shrink", "variant", "onChange", "onBlur", "onFocus", "value", "name", "type", "error", "extraText", "placeholder", "extraTextAlign", "labelAlign", "required", "disabled"]);

  return /*#__PURE__*/React.createElement(Wrapper$a, _extends({
    label: label
  }, rest), label && /*#__PURE__*/React.createElement(Label$2, {
    shrink: shrink || trim_1(value).length > 0,
    htmlFor: id,
    disabled: disabled
  }, label), /*#__PURE__*/React.createElement(StyledInput, _extends({
    "aria-live": "polite",
    id: id,
    label: label,
    disabled: disabled,
    error: error,
    name: name || id,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    type: type,
    value: value,
    variant: variant,
    placeholder: trim_1(value).length === 0 ? placeholder : undefined,
    ref: ref,
    required: required
  }, rest)), extraText && /*#__PURE__*/React.createElement(ExtraText, {
    align: extraTextAlign,
    error: error
  }, extraText));
});
var Wrapper$a = styled.div(_templateObject$l(), space$1, function (props) {
  return props.label && css(_templateObject2$g(), fontSmall);
});
var Label$2 = styled.label(_templateObject3$d(), fontLarge, function (props) {
  return props.theme.spaceUnit * 2;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.shrink && css(_templateObject4$6(), fontSmall);
}, function (props) {
  return props.disabled && css(_templateObject5$5());
});
var StyledInput = styled.input(_templateObject6$5(), animations.transitionAll, fontLarge, function (props) {
  return props.theme.spaceUnit * 7;
}, function (props) {
  return props.theme.spaceUnit * (props.label ? 2 : 0);
}, function (props) {
  return props.theme.spaceUnit * 2;
}, function (props) {
  return props.theme.spaceUnit * 2;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.variant === 'borderless' ? 'transparent' : props.theme.colors.greyMed;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.label ? 0 : 1;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.error && css(_templateObject7$4(), props.theme.colors.alert, props.theme.colors.alert, ExtraText, props.theme.colors.alert);
}, function (props) {
  return props.placeholder && css(_templateObject8$4(), props.theme.colors.secondary);
}, function (props) {
  return props.disabled && css(_templateObject9$4(), props.theme.colors.secondary, props.theme.colors.secondary, props.theme.colors.greyLight, props.variant === 'borderless' ? 'transparent' : props.theme.colors.greyMed, props.theme.colors.greyMed, ExtraText, props.theme.colors.greyMed);
}, function (props) {
  return props.type === 'number' && css(_templateObject10$3());
});
var ExtraText = styled.div(_templateObject11$3(), fontSmall, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.align;
}, function (props) {
  return props.error && css(_templateObject12$2(), props.theme.colors.alert);
});
Input$2.propTypes = propTypes$n;
Input$2.defaultProps = defaultProps$n;

function _templateObject11$4() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject11$4 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$4() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject10$4 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"]);

  _templateObject9$5 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n\n  cursor: inherit;\n  opacity: 0;\n"]);

  _templateObject8$5 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n      "]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteral(["\n        animation: ", " 0.15s ease forwards;\n      "]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      border-color: ", ";\n    "]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: flex;\n  align-items: inherit;\n  justify-content: inherit;\n  width: ", "px;\n  height: ", "px;\n\n  background: ", ";\n  border: 2px solid\n    ", ";\n  border-radius: 50%;\n\n  cursor: pointer;\n\n  transition: ", ";\n\n  ", "\n\n  &:after {\n    position: absolute;\n\n    height: 100%;\n    width: 100%;\n\n    background: ", ";\n    border-radius: 50%;\n\n    animation: none;\n    transform: scale(0);\n\n    content: '';\n\n    ", ";\n\n    ", ";\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale(0);\n  }\n  to {\n    opacity: 1;\n    transform: scale(0.6);\n  }\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  cursor: pointer;\n\n  ", "\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$o = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};
var defaultProps$o = {
  disabled: false,
  checked: false
};

function RadioButton(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      checked = _ref.checked,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["id", "name", "label", "onChange", "value", "checked", "disabled"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "block"
  }, rest), /*#__PURE__*/React.createElement(Wrapper$b, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Radio, {
    checked: checked,
    disabled: disabled,
    mr: 1
  }), /*#__PURE__*/React.createElement(Input$3, _extends({
    id: id,
    name: name,
    type: "radio",
    onChange: onChange,
    value: value,
    checked: checked,
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement(Label$3, {
    htmlFor: id,
    checked: checked,
    disabled: disabled,
    mb: 0
  }, label)));
}

var Wrapper$b = styled.div(_templateObject$m(), function (props) {
  return props.disabled && css(_templateObject2$h());
});
var RadioAnimation = keyframes(_templateObject3$e());
var Radio = styled(Box)(_templateObject4$7(), function (props) {
  return props.theme.spaceUnit * 3;
}, function (props) {
  return props.theme.spaceUnit * 3;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors[props.checked ? 'primary' : 'greyMed'];
}, function (props) {
  return props.theme.animations.transitionAll;
}, function (props) {
  return props.disabled && css(_templateObject5$6(), props.theme.colors.greyLight, props.theme.colors.greyMed);
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.checked && css(_templateObject6$6(), RadioAnimation);
}, function (props) {
  return props.disabled && css(_templateObject7$5(), props.theme.colors.greyMed);
});
var Input$3 = styled.input(_templateObject8$5());
var Label$3 = styled(Text).attrs({
  as: 'label'
})(_templateObject9$5(), function (props) {
  return props.checked && css(_templateObject10$4(), props.theme.colors.primary);
}, function (props) {
  return props.disabled && css(_templateObject11$4(), props.theme.colors.secondary);
});
RadioButton.propTypes = propTypes$o;
RadioButton.defaultProps = defaultProps$o;

function _templateObject3$f() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        content: '*';\n        display: inline-block;\n        margin-left: 0.3em;\n      "]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n      border: 0;\n      clip: rect(0 0 0 0);\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 1px;\n    "]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  color: ", ";\n  display: inline-block;\n  margin-bottom: 8px;\n  text-align: ", ";\n  width: 100%;\n\n  ", " ::after {\n    ", ";\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$p = {
  children: PropTypes.node,
  inputId: PropTypes.string,
  hideLabel: PropTypes.bool,
  required: PropTypes.bool,
  hasError: PropTypes.bool
};
var defaultProps$p = {
  children: null,
  hideLabel: false,
  inputId: null,
  required: false,
  hasError: false
};

var Label$4 = function Label(_ref) {
  var children = _ref.children,
      hideLabel = _ref.hideLabel,
      inputId = _ref.inputId,
      required = _ref.required,
      hasError = _ref.hasError,
      rest = _objectWithoutProperties(_ref, ["children", "hideLabel", "inputId", "required", "hasError"]);

  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    hideLabel: hideLabel,
    htmlFor: inputId,
    required: required,
    hasError: hasError
  }, rest), children);
};

var StyledLabel = styled.label(_templateObject$n(), fontLabel(), function (props) {
  return props.hasError ? colors.alert : colors.black;
}, function (props) {
  return props.align;
}, function (props) {
  return props.hideLabel && css(_templateObject2$i());
}, function (props) {
  return props.required && css(_templateObject3$f(), colors.alert);
}, space$1, color, textAlign);
Label$4.propTypes = propTypes$p;
Label$4.defaultProps = defaultProps$p;

function _templateObject5$7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: ", "px;\n  top: calc(50% - 12px);\n  pointer-events: none;\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n\n      :focus {\n        border: 1px solid ", ";\n      }\n    "]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border: 1px solid\n        ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      option {\n        color: ", ";\n      }\n      option:first-child {\n        color: ", ";\n      }\n    "]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  display: block;\n  width: 100%;\n  height: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n\n  color: ", ";\n\n  appearance: none;\n  background: ", ";\n  border-radius: ", "px;\n  border: 1px solid\n    ", ";\n  outline: none;\n\n  cursor: pointer;\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$q = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  hideLabel: PropTypes.bool,
  id: PropTypes.string,
  labelAlign: PropTypes.oneOf(['left', 'center', 'right']),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(['standard', 'borderless'])
};
var defaultProps$q = {
  disabled: false,
  error: false,
  hideLabel: false,
  id: null,
  labelAlign: 'left',
  placeholder: null,
  required: false,
  value: null,
  variant: 'standard'
};

function Select(_ref) {
  var variant = _ref.variant,
      required = _ref.required,
      disabled = _ref.disabled,
      error = _ref.error,
      hideLabel = _ref.hideLabel,
      labelAlign = _ref.labelAlign,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["variant", "required", "disabled", "error", "hideLabel", "labelAlign", "id", "label", "name", "onChange", "options", "placeholder", "value"]);

  var inputId = id || name;
  return /*#__PURE__*/React.createElement(Box, rest, label && /*#__PURE__*/React.createElement(Label$4, {
    hideLabel: hideLabel,
    inputId: inputId,
    required: required,
    textAlign: labelAlign
  }, label), /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(StyledSelect, {
    variant: variant,
    disabled: disabled,
    error: error,
    id: inputId,
    name: name,
    onChange: onChange,
    value: value,
    required: required
  }, /*#__PURE__*/React.createElement("option", {
    disabled: true,
    value: ""
  }, placeholder), options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      value: option.value,
      key: option.value,
      disabled: option.disabled
    }, option.label);
  })), /*#__PURE__*/React.createElement(StyledIconExpandMore, {
    color: disabled ? 'greyMed' : 'primary'
  })));
}

var StyledSelect = styled.select(_templateObject$o(), fontLarge, function (props) {
  return props.theme.spaceUnit * 7;
}, function (props) {
  return props.theme.spaceUnit * 2;
}, function (props) {
  return props.theme.spaceUnit * 2;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.variant === 'borderless' ? 'transparent' : props.theme.colors.greyMed;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return !props.value && css(_templateObject2$j(), props.theme.colors.secondary, props.theme.colors.primary, props.theme.colors.secondary);
}, function (props) {
  return props.disabled && css(_templateObject3$g(), props.theme.colors.greyLight, props.variant === 'borderless' ? 'transparent' : props.theme.colors.greyMed);
}, function (props) {
  return props.error && css(_templateObject4$8(), props.theme.colors.alert, props.theme.colors.alert);
});
var StyledIconExpandMore = styled(IconExpandMore)(_templateObject5$7(), function (props) {
  return props.theme.spaceUnit * 2;
});
Select.propTypes = propTypes$q;
Select.defaultProps = defaultProps$q;

function _templateObject3$h() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n\n      background-color: ", ";\n      border: 1px solid\n        ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n\n      :focus {\n        border: 1px solid ", ";\n      }\n    "]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  max-width: 100%;\n\n  color: ", ";\n\n  border-radius: ", "px;\n  border: 1px solid\n    ", ";\n\n  box-sizing: border-box;\n  display: block;\n  height: auto;\n  outline: none;\n  padding: 8px 12px 8px 12px;\n  width: 100%;\n\n  &::placeholder {\n    color: ", ";\n    padding: 2px 0px;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$r = {
  variant: PropTypes.oneOf(['standard', 'borderless']),
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  hideLabel: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  value: PropTypes.string,
  // forwardRef: PropTypes.oneOfType([
  //   PropTypes.func,
  //   PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  // ]),
  required: PropTypes.bool,
  labelAlign: PropTypes.oneOf(['left', 'center', 'right'])
};
var defaultProps$r = {
  variant: 'standard',
  disabled: false,
  hasError: false,
  hideLabel: false,
  id: null,
  onChange: null,
  placeholder: null,
  rows: 3,
  value: undefined,
  // forwardRef: null,
  required: false,
  labelAlign: 'left'
};

function TextArea(_ref) {
  var variant = _ref.variant,
      disabled = _ref.disabled,
      hasError = _ref.hasError,
      hideLabel = _ref.hideLabel,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      required = _ref.required,
      rows = _ref.rows,
      value = _ref.value,
      forwardRef = _ref.forwardRef,
      labelAlign = _ref.labelAlign,
      rest = _objectWithoutProperties(_ref, ["variant", "disabled", "hasError", "hideLabel", "id", "label", "name", "onChange", "placeholder", "required", "rows", "value", "forwardRef", "labelAlign"]);

  var inputId = id || name;
  return /*#__PURE__*/React.createElement(Box, rest, /*#__PURE__*/React.createElement(Label$4, {
    hideLabel: hideLabel,
    inputId: inputId,
    required: required,
    align: labelAlign
  }, label), /*#__PURE__*/React.createElement(TextInput, {
    id: inputId,
    variant: variant,
    disabled: disabled,
    hasError: hasError,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    rows: rows,
    value: value,
    "aria-live": "polite",
    ref: forwardRef
  }));
}

var TextInput = styled.textarea(_templateObject$p(), fontRegular(), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.variant === 'borderless' ? 'transparent' : props.theme.colors.greyMed;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.hasError && css(_templateObject2$k(), props.theme.colors.alert, props.theme.colors.alert);
}, function (props) {
  return props.disabled && css(_templateObject3$h(), props.theme.colors.secondary, props.theme.colors.greyLight, props.variant === 'borderless' ? 'transparent' : props.theme.colors.greyMed);
});
TextArea.propTypes = propTypes$r;
TextArea.defaultProps = defaultProps$r;

var propTypes$s = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$s = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconAdd(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconAdd.propTypes = propTypes$s;
IconAdd.defaultProps = defaultProps$s;

var propTypes$t = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$t = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconRemove(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13H5v-2h14v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconRemove.propTypes = propTypes$t;
IconRemove.defaultProps = defaultProps$t;

function _templateObject2$l() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n\n  display: flex;\n  justify-content: space-between;\n  height: 60px;\n\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: 0 ", "px;\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$u = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  step: PropTypes.number,
  unit: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  alignLabel: PropTypes.oneOf(['left', 'center', 'right'])
};
var defaultProps$u = {
  disabled: false,
  label: null,
  onChange: null,
  step: 1,
  unit: null,
  variant: 'primary',
  alignLabel: 'center'
};

function Stepper(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      alignLabel = _ref.alignLabel,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      unit = _ref.unit,
      variant = _ref.variant,
      value = _ref.value,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["disabled", "label", "alignLabel", "min", "max", "step", "unit", "variant", "value", "onChange"]);

  return /*#__PURE__*/React.createElement(StepperWrapper, rest, label && /*#__PURE__*/React.createElement(Label$4, {
    textAlign: alignLabel
  }, label), /*#__PURE__*/React.createElement(Wrapper$c, {
    variant: variant
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return onChange(value - step);
    },
    disabled: disabled || value <= min
  }, /*#__PURE__*/React.createElement(IconRemove, {
    size: 20
  })), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    color: "primary",
    mx: 2
  }, value, " ", unit), /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return onChange(value + step);
    },
    disabled: disabled || value >= max
  }, /*#__PURE__*/React.createElement(IconAdd, {
    size: 20
  }))));
}

var StepperWrapper = styled.div(_templateObject$q(), space$1);
var Wrapper$c = styled.div(_templateObject2$l(), function (props) {
  return props.variant === 'primary' ? props.theme.colors.white : props.theme.colors.greyLight;
}, function (props) {
  return props.theme.space[1];
}, function (props) {
  return props.theme.space[1];
});
Stepper.propTypes = propTypes$u;
Stepper.defaultProps = defaultProps$u;

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  ", ";\n  ", ";\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$v = {
  theme: PropTypes.shape({
    colors: PropTypes.object
  }).isRequired,
  color: PropTypes.oneOf(['primary', 'secondary', 'black', 'white']),
  size: PropTypes.number
};
var defaultProps$v = {
  color: 'primary',
  size: 96
};

function Logo(_ref) {
  var theme = _ref.theme,
      color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["theme", "color", "size"]);

  return /*#__PURE__*/React.createElement(Svg$1, _extends({
    width: size * 3.75,
    height: size,
    viewBox: "0 0 360 96",
    role: "img"
  }, rest), /*#__PURE__*/React.createElement("g", {
    fill: theme.colors[color],
    fillRule: "evenodd",
    role: "presentation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.144 43c0 6.752-5.475 12.227-12.228 12.227-6.752 0-12.227-5.474-12.227-12.227 0-6.754 5.475-12.227 12.227-12.227 6.753 0 12.228 5.473 12.228 12.226M.901.167h54.597v16.729H20.743V35.96h34.755v16.859H20.743v40.072H.901zM175.796 81.998l13.876-7.133c.908 4.669 5.187 7.78 11.282 7.78 5.966 0 9.467-2.333 9.467-6.093 0-5.577-5.058-5.966-13.357-9.078-12.709-4.8-19.453-9.338-19.453-18.675 0-11.672 9.856-20.36 26.067-20.36 11.282 0 19.712 4.798 23.343 12.839l-13.228 6.613c-1.427-4.668-5.058-7.132-10.375-7.132-5.446 0-8.948 2.464-8.948 5.965 0 5.058 5.447 6.354 14.525 9.337 12.71 4.15 18.804 9.337 18.804 19.194 0 11.93-9.856 20.1-26.455 20.1-13.099 0-22.566-5.187-25.548-13.357M233.244.167h18.026v58.098l23.084-27.493h21.659l-25.03 27.493 27.493 34.626H276.17l-24.9-32.939v32.939h-18.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.37 61.767c0-11.542-6.355-18.156-15.563-18.156-9.856 0-15.82 6.873-15.82 18.156 0 11.152 5.835 17.767 15.691 17.767 9.856 0 15.692-6.485 15.692-17.767m-49.67.13c0-20.88 10.505-33.199 28.142-33.199 9.079 0 16.082 4.02 20.88 12.32V30.771h17.119v62.12h-17.509l.26-8.949c-4.928 7.911-11.541 11.412-21.399 11.412-16.08 0-27.493-12.839-27.493-33.458M62.581 92.891h18.026V30.772H62.581zM141.689 43.481c5.27 0 9.075 1.737 11.396 5.052l-26.551 13.133c-.947-11.186 7.114-18.184 15.155-18.184m.259 36.181c-4.661 0-8.46-1.662-11.105-4.37l31.119-15.986 11.06-5.68a37.297 37.297 0 0 0-.822-3.546c-3.871-13.576-14.93-21.383-30.511-21.383-19.453 0-32.811 14.264-32.811 33.458 0 19.842 12.19 33.2 32.68 33.2 13.229 0 22.696-5.188 29.44-16.082l-14.525-7.261c-3.242 5.186-8.041 7.65-14.525 7.65"
  })));
}

var Svg$1 = styled.svg(_templateObject$r(), layout, space$1);
Logo.propTypes = propTypes$v;
Logo.defaultProps = defaultProps$v;
var Logo$1 = withTheme(Logo);

var f1 = [{
  d: 'M13.995 50.03h2.663v2.509h-2.663V50.03zm-4.164 0h2.664v2.509H9.831V50.03zm-4.165 0h2.665v2.509H5.666V50.03zm-4.165 0h2.665v2.509H1.501V50.03zm12.494-4.008h2.663v2.508h-2.663v-2.508zm-4.164 0h2.664v2.508H9.831v-2.508zm-4.165 0h2.665v2.508H5.666v-2.508zm-4.165 0h2.665v2.508H1.501v-2.508zm12.494-28.37h2.663v18.853h-2.663V17.652zm0 20.353h2.663v2.508h-2.663v-2.508zm0 4.008h2.663v2.509h-2.663v-2.509zm-4.164 0h2.664v2.509H9.831v-2.509zm-4.165 0h2.665v2.509H5.666v-2.509zm-1.5 2.509H1.501v-2.509h2.665v2.509zm0-4.009H1.501v-2.508h2.665v2.508zm0-4.008H1.501V17.652h2.665v18.853zm5.665-18.853h2.664v18.853H9.831V17.652zm0 20.353h2.664v2.508H9.831v-2.508zm-1.5 2.508H5.666v-2.508h2.665v2.508zm0-4.008H5.666V17.652h2.665v18.853zm47.633-18.853V.118H0v93.049h.001v.001h1.5V54.039h2.665v39.129h1.5V54.039h2.665v39.129h1.5V54.039h2.664v39.129h1.5V54.039h2.664v39.128h.002v.001h1.5V54.039h37.803v-1.5H18.161V50.03h37.803v-1.5H18.161v-2.508h37.803v-1.5H18.161v-2.509h37.803v-1.5H18.161v-2.508h37.803v-1.5H18.161V17.652h37.803z'
}];
var f2 = [{
  d: 'M39.824 34.478c-6.421 0-11.627 5.206-11.627 11.627 0 6.422 5.206 11.628 11.627 11.628 6.422 0 11.628-5.206 11.628-11.628 0-6.421-5.206-11.627-11.628-11.627'
}, {
  d: 'M.215.06v93.048h18.159V17.594h37.805V.06z'
}];
var f3 = [{
  d: 'M.215.06v93.048h.002v.001h1.5V17.593h2.664V93.11h1.5V17.593h2.665V93.11h1.5V17.593h2.665V93.11h1.5V17.593h2.663v75.515h.001v.001h1.5V17.593H56.18V.06z'
}, {
  d: 'M39.825 34.478c-6.422 0-11.628 5.206-11.628 11.628 0 6.42 5.206 11.627 11.628 11.627 6.421 0 11.627-5.206 11.627-11.627 0-6.422-5.206-11.628-11.627-11.628'
}];
var f4 = [{
  d: 'M39.823 34.478c-6.42 0-11.627 5.206-11.627 11.628 0 6.42 5.206 11.627 11.627 11.627 6.422 0 11.628-5.206 11.628-11.627 0-6.422-5.206-11.628-11.628-11.628'
}, {
  d: 'M14.21 13.584h2.663v2.508H14.21v-2.508zm-4.165 0h2.665v2.508h-2.665v-2.508zm-4.164 0h2.664v2.508H5.881v-2.508zm-4.165 0h2.665v2.508H1.716v-2.508zM14.21 9.576h2.663v2.508H14.21V9.576zm-4.165 0h2.665v2.508h-2.665V9.576zm-4.164 0h2.664v2.508H5.881V9.576zm-4.165 0h2.665v2.508H1.716V9.576zm2.665-5.509H1.716V1.559h2.665v2.508zm4.164 0H5.881V1.559h2.664v2.508zm4.165 0h-2.665V1.559h2.665v2.508zm1.5-2.508h2.663v2.508H14.21V1.559zm0 4.008h2.663v2.509H14.21V5.567zm-4.165 0h2.665v2.509h-2.665V5.567zM4.381 8.076H1.716V5.567h2.665v2.509zm1.5-2.509h2.664v2.509H5.881V5.567zM56.18 1.559v-1.5H.217V.06H.216v.148H.215v92.9h.001v.001h1.5V17.593h2.665v75.516h1.5V17.593h2.664v75.516h1.5V17.593h2.665v75.516h1.5V17.593h2.663v75.515h.001v.001h1.5V17.593H56.18v-1.5H18.374v-2.509H56.18v-1.5H18.374V9.576H56.18v-1.5H18.374V5.567H56.18v-1.5H18.374V1.559H56.18z'
}];

var symbols = /*#__PURE__*/Object.freeze({
  __proto__: null,
  f1: f1,
  f2: f2,
  f3: f3,
  f4: f4
});

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$w = {
  variant: PropTypes.oneOf([1, 2, 3, 4]),
  color: PropTypes.oneOf(['black', 'white', 'primary']),
  height: PropTypes.number
};
var defaultProps$w = {
  variant: 1,
  color: 'black',
  height: 94
};

function LogoIcon(_ref) {
  var variant = _ref.variant,
      color = _ref.color,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["variant", "color", "height"]);

  var iconPaths = symbols["f".concat(variant)];
  return /*#__PURE__*/React.createElement(Svg$2, _extends({
    width: height * 0.606,
    height: height,
    viewBox: "0 0 57 94",
    role: "img"
  }, rest), iconPaths && iconPaths.map(function (pathProps, i) {
    return /*#__PURE__*/React.createElement("path", _extends({
      // eslint-disable-next-line react/no-array-index-key
      key: i,
      role: "presentation",
      fill: colors[color]
    }, pathProps));
  }));
}

var Svg$2 = styled.svg(_templateObject$s(), layout, space$1);
LogoIcon.propTypes = propTypes$w;
LogoIcon.defaultProps = defaultProps$w;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$1.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$2.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", "\n\n  color: ", ";\n  background: none;\n\n  appearance: none;\n  outline: none;\n  border: 0;\n\n  &:visited {\n    color: ", ";\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$x = {
  color: PropTypes.oneOf(keys_1(colors)),
  size: PropTypes.oneOf(['smaller', 'small', 'medium', 'large']),
  underline: PropTypes.bool,
  bold: PropTypes.bool
};
var defaultProps$x = {
  color: 'primary',
  size: 'medium',
  underline: false,
  bold: false
};
var Link = styled.a(_templateObject$t(), link, space$1, textAlign, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return transparentize('0.8', props.theme.colors[props.color]);
});
Link.propTypes = propTypes$x;
Link.defaultProps = defaultProps$x;

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: list-item;\n  margin-left: ", "px;\n  margin-bottom: ", "px;\n  list-style-type: none;\n  list-style-position: outside;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ::before {\n    position: absolute;\n    top: auto;\n    bottom: auto;\n    margin-left: -", "px;\n    user-select: none;\n    pointer-events: none;\n    content: '\u2022';\n  }\n\n  p,\n  a {\n    margin: 0;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$y = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['smaller', 'small', 'medium', 'large'])
};
var defaultProps$y = {
  children: null,
  size: 'medium'
};

function ListItem(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(Wrapper$d, {
    size: size
  }, children);
}

var Wrapper$d = styled.li(_templateObject$u(), function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.space[1];
}, function (props) {
  return props.size === 'large' && fontLarge;
}, function (props) {
  return props.size === 'medium' && fontRegular;
}, function (props) {
  return props.size === 'small' && fontSmall;
}, function (props) {
  return props.size === 'smaller' && fontSmaller;
}, function (props) {
  return props.theme.space[3];
});
ListItem.propTypes = propTypes$y;
ListItem.defaultProps = defaultProps$y;

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  list-style: none;\n\n  ", ";\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$z = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['smaller', 'small', 'medium', 'large'])
};
var defaultProps$z = {
  children: null,
  size: 'medium'
};

function List(_ref) {
  var children = _ref.children,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["children", "size"]);

  return /*#__PURE__*/React.createElement(Wrapper$e, rest, React.Children.toArray(children).map(function (item) {
    return /*#__PURE__*/React.cloneElement(item, {
      size: size
    });
  }));
}

var Wrapper$e = styled.ul(_templateObject$v(), function (props) {
  return props.theme.space[1];
}, function (props) {
  return props.theme.space[1];
}, space$1);
List.propTypes = propTypes$z;
List.defaultProps = defaultProps$z;
List.Item = ListItem;

var propTypes$A = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$A = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconAddCircle(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconAddCircle.propTypes = propTypes$A;
IconAddCircle.defaultProps = defaultProps$A;

var propTypes$B = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$B = {
  size: 24,
  color: 'secondary',
  title: 'Arrow back'
};

function IconArrowBack(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  })));
}

IconArrowBack.propTypes = propTypes$B;
IconArrowBack.defaultProps = defaultProps$B;

var propTypes$C = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$C = {
  size: 24,
  color: 'secondary',
  title: 'Arrow forward'
};

function IconArrowForward(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z"
  })));
}

IconArrowForward.propTypes = propTypes$C;
IconArrowForward.defaultProps = defaultProps$C;

var propTypes$D = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$D = {
  size: 24,
  color: 'secondary',
  title: 'Assignment icon'
};

function IconAssignment(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm1 14H8c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1zm3-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconAssignment.propTypes = propTypes$D;
IconAssignment.defaultProps = defaultProps$D;

var propTypes$E = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$E = {
  size: 24,
  color: 'secondary',
  title: 'At icon'
};

function IconAt(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest, {
    viewBox: "-2 -2 24 24"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.103 0c2.006 0 3.728.375 5.167 1.125 1.439.75 2.533 1.772 3.283 3.066.75 1.293 1.126 2.744 1.126 4.35 0 1.333-.203 2.477-.609 3.434-.406.957-.968 1.684-1.688 2.181-.72.498-1.538.746-2.457.746-.811 0-1.47-.176-1.974-.528a2.213 2.213 0 01-.942-1.4h-.046c-.413.597-.876 1.067-1.389 1.412-.513.344-1.16.516-1.94.516-1.133 0-2.017-.378-2.652-1.136-.636-.758-.953-1.764-.953-3.02 0-1.087.206-2.078.62-2.973.413-.896.983-1.604 1.71-2.124s1.558-.781 2.492-.781c.627 0 1.178.13 1.653.39.475.26.811.628 1.01 1.103h.07l.229-1.286h2.48l-.988 5.419c-.076.459-.114.819-.114 1.079 0 .444.091.78.275 1.01.184.23.482.345.896.345.306 0 .612-.146.918-.437.306-.29.563-.765.77-1.423.206-.659.31-1.5.31-2.526 0-1.286-.276-2.411-.827-3.376-.551-.964-1.37-1.714-2.457-2.25-1.087-.536-2.411-.803-3.973-.803-1.47 0-2.778.317-3.926.952-1.148.636-2.051 1.57-2.71 2.802-.658 1.232-.987 2.698-.987 4.397 0 1.53.302 2.87.907 4.018a6.364 6.364 0 002.618 2.664c1.14.628 2.499.941 4.075.941 1.118 0 2.078-.137 2.882-.413.804-.275 1.397-.65 1.78-1.125h3.214c-.597 1.087-1.58 1.967-2.95 2.64-1.37.674-3.012 1.011-4.926 1.011-2.05 0-3.834-.41-5.35-1.228-1.515-.82-2.683-1.964-3.502-3.433C.41 13.869 0 12.178 0 10.264 0 8.136.432 6.3 1.297 4.754c.865-1.547 2.063-2.726 3.594-3.537C6.42.406 8.159 0 10.103 0zm.184 6.866a2.09 2.09 0 00-1.47.574c-.413.382-.727.872-.941 1.47a5.398 5.398 0 00-.321 1.836c0 .659.145 1.187.436 1.585.29.398.689.597 1.194.597.612 0 1.136-.188 1.573-.563.436-.375.765-.865.987-1.47a5.52 5.52 0 00.333-1.917c0-.704-.157-1.232-.47-1.584-.314-.352-.755-.528-1.321-.528z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconAt.propTypes = propTypes$E;
IconAt.defaultProps = defaultProps$E;

var propTypes$F = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$F = {
  size: 24,
  color: 'secondary',
  title: 'Attachment icon'
};

function IconAttachment(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconAttachment.propTypes = propTypes$F;
IconAttachment.defaultProps = defaultProps$F;

var propTypes$G = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$G = {
  size: 24,
  color: 'secondary',
  title: 'Beach access icon'
};

function IconBeachAccess(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.253 14.845l1.589-1.589 7.156 7.16L20.412 22l-7.16-7.156zm4.77-6.367L21.201 5.3C16.812.91 9.701.9 5.311 5.278c4.367-1.445 9.234-.278 12.712 3.2zM5.278 5.311C.9 9.701.91 16.812 5.3 21.201l3.178-3.178C5 14.545 3.833 9.678 5.278 5.311zM5.3 5.29L5.29 5.3c-.422 3.345 1.3 7.645 4.778 11.134l6.367-6.367C12.956 6.59 8.644 4.867 5.3 5.29z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconBeachAccess.propTypes = propTypes$G;
IconBeachAccess.defaultProps = defaultProps$G;

var propTypes$H = {
  size: PropTypes.number,
  title: PropTypes.string
};
var defaultProps$H = {
  size: 24,
  title: 'Braintree logo'
};

function IconBraintree(_ref) {
  var size = _ref.size,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["size", "title"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    id: "braintree",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React.createElement(Icon.G, {
    id: "braintree-b"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: size,
    height: size
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,20 L12.6413793,20 C16.337931,20 18.6,18.3724138 18.6,15.4482759 C18.6,13.6 17.2482759,12.2482759 15.3448276,11.7241379 C16.6689655,11.2 17.7172414,10.0965517 17.7172414,8.30344828 C17.7172414,5.57241379 15.6482759,4 12.2551724,4 L5,4 L5,6.34482759 L6.71034483,6.34482759 L6.71034483,17.6551724 L5,17.6551724 L5,20 Z M9.24827586,10.7034483 L9.24827586,6.34482759 L11.9793103,6.34482759 C14.0482759,6.34482759 15.1517241,7.08965517 15.1517241,8.52413793 C15.1517241,9.93103448 14.0758621,10.7034483 12.0068966,10.7034483 L9.24827586,10.7034483 Z M9.24827586,17.6551724 L9.24827586,12.9655172 L12.2,12.9655172 C14.737931,12.9655172 16.0344828,13.7931034 16.0344828,15.3103448 C16.0344828,16.8551724 14.8206897,17.6551724 12.3931034,17.6551724 L9.24827586,17.6551724 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconBraintree.propTypes = propTypes$H;
IconBraintree.defaultProps = defaultProps$H;

var propTypes$I = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$I = {
  size: 24,
  color: 'secondary',
  title: 'Calendar event icon'
};

function IconCalendarEvent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  })));
}

IconCalendarEvent.propTypes = propTypes$I;
IconCalendarEvent.defaultProps = defaultProps$I;

var propTypes$J = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$J = {
  size: 24,
  color: 'secondary',
  title: 'Call icon'
};

function IconCall(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.23 15.26l-2.54-.29a1.99 1.99 0 00-1.64.57l-1.84 1.84a15.045 15.045 0 01-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.001 2.001 0 00-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconCall.propTypes = propTypes$J;
IconCall.defaultProps = defaultProps$J;

var propTypes$K = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$K = {
  size: 24,
  color: 'secondary',
  title: 'Check circle icon'
};

function IconCancel(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    opacity: ".87",
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41L10.59 12 7.7 9.11c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
  })));
}

IconCancel.propTypes = propTypes$K;
IconCancel.defaultProps = defaultProps$K;

var propTypes$L = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$L = {
  size: 24,
  color: 'secondary',
  title: 'Check circle icon'
};

function IconCheckCircle(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"
  })));
}

IconCheckCircle.propTypes = propTypes$L;
IconCheckCircle.defaultProps = defaultProps$L;

var propTypes$M = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$M = {
  size: 24,
  color: 'secondary',
  title: 'Chevron left icon'
};

function IconChevronLeft(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  })));
}

IconChevronLeft.propTypes = propTypes$M;
IconChevronLeft.defaultProps = defaultProps$M;

var propTypes$N = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$N = {
  size: 24,
  color: 'secondary',
  title: 'Chevron right icon'
};

function IconChevronRight(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  })));
}

IconChevronRight.propTypes = propTypes$N;
IconChevronRight.defaultProps = defaultProps$N;

var propTypes$O = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$O = {
  size: 24,
  color: 'secondary',
  title: 'Close icon'
};

function IconClosingDay(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 2.45l7 5.25a1 1 0 01.266.3H21a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V9a1 1 0 011-1h1.134a1 1 0 01.266-.3l7-5.25a1 1 0 011.2 0zm-4.136 8.229a.556.556 0 00-.785.785L11.214 15l-3.535 3.536a.556.556 0 10.785.785L12 15.786l3.536 3.535a.556.556 0 00.785-.785L12.786 15l3.535-3.536a.556.556 0 00-.785-.785L12 14.214zM11.4 4.45L6.666 8h10.668L12.6 4.45a1 1 0 00-1.2 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconClosingDay.propTypes = propTypes$O;
IconClosingDay.defaultProps = defaultProps$O;

var propTypes$P = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$P = {
  size: 24,
  color: 'secondary',
  title: 'Comment icon'
};

function IconComment(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconComment.propTypes = propTypes$P;
IconComment.defaultProps = defaultProps$P;

var propTypes$Q = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$Q = {
  size: 24,
  color: 'secondary',
  title: 'Date range icon'
};

function IconDateRange(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconDateRange.propTypes = propTypes$Q;
IconDateRange.defaultProps = defaultProps$Q;

var propTypes$R = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$R = {
  size: 24,
  color: 'secondary',
  title: 'Directions icon'
};

function IconDirections(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"
  })));
}

IconDirections.propTypes = propTypes$R;
IconDirections.defaultProps = defaultProps$R;

var propTypes$S = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$S = {
  size: 35,
  color: 'secondary',
  title: 'Drawer handle icon'
};

function IconDrawerHandle(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "0 0 35 8",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.267.66c-.78-.26-2.04-.26-2.82 0l-13.76 1.586L3.927.66c-.78-.26-2.04-.26-2.82 0-.78.26-.78 2.68 0 2.94l15.18 4.06c.78.26 2.04.26 2.82 0l15.18-4.06c.795-.213.76-2.68-.02-2.94z"
  })));
}

IconDrawerHandle.propTypes = propTypes$S;
IconDrawerHandle.defaultProps = defaultProps$S;

var propTypes$T = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$T = {
  size: 24,
  color: 'secondary',
  title: 'Edit icon'
};

function IconEdit(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  })));
}

IconEdit.propTypes = propTypes$T;
IconEdit.defaultProps = defaultProps$T;

var propTypes$U = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$U = {
  size: 24,
  color: 'secondary',
  title: 'Email icon'
};

function IconEmail(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25a.85.85 0 11.9-1.44L12 11l6.7-4.19a.85.85 0 11.9 1.44z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconEmail.propTypes = propTypes$U;
IconEmail.defaultProps = defaultProps$U;

var propTypes$V = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$V = {
  size: 24,
  color: 'secondary',
  title: 'Error outline'
};

function IconErrorOutline(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"
  })));
}

IconErrorOutline.propTypes = propTypes$V;
IconErrorOutline.defaultProps = defaultProps$V;

var propTypes$W = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$W = {
  size: 24,
  color: 'secondary',
  title: 'Expand less'
};

function IconExpandLess(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
  })));
}

IconExpandLess.propTypes = propTypes$W;
IconExpandLess.defaultProps = defaultProps$W;

var propTypes$X = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$X = {
  size: 24,
  color: 'secondary',
  title: 'Feedback icon'
};

function IconFeedback(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconFeedback.propTypes = propTypes$X;
IconFeedback.defaultProps = defaultProps$X;

var propTypes$Y = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$Y = {
  size: 24,
  color: 'secondary',
  title: 'Healing icon'
};

function IconHealing(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }));
}

IconHealing.propTypes = propTypes$Y;
IconHealing.defaultProps = defaultProps$Y;

var propTypes$Z = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$Z = {
  size: 24,
  color: 'secondary',
  title: 'Help outline'
};

function IconHelpOutline(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47z"
  })));
}

IconHelpOutline.propTypes = propTypes$Z;
IconHelpOutline.defaultProps = defaultProps$Z;

var propTypes$_ = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$_ = {
  size: 24,
  color: 'secondary',
  title: 'Home cleaning icon'
};

function IconHome(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
  })));
}

IconHome.propTypes = propTypes$_;
IconHome.defaultProps = defaultProps$_;

var propTypes$$ = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$$ = {
  size: 24,
  color: 'secondary',
  title: 'Key icon'
};

function IconKey(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "-3 -3 24 24"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.653 7.8L0 14.451l2.571 2.572 1.286-1.286 2.571 2.571L9 15.738l-2.572-2.571 2.797-2.797a5.446 5.446 0 0 0 6.203-1.06 5.459 5.459 0 0 0 0-7.714 5.459 5.459 0 0 0-7.714 0 5.446 5.446 0 0 0-1.06 6.203zm6.24-1.044a1.824 1.824 0 0 1-2.571 0 1.824 1.824 0 0 1 0-2.571 1.824 1.824 0 0 1 2.57 0 1.824 1.824 0 0 1 0 2.57z"
  })));
}

IconKey.propTypes = propTypes$$;
IconKey.defaultProps = defaultProps$$;

var propTypes$10 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$10 = {
  size: 24,
  color: 'secondary',
  title: 'Key attention icon'
};

function IconKeyAttention(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "-2 -1 24 24"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.653 10.8a5.446 5.446 0 0 1 1.06-6.204 5.459 5.459 0 0 1 7.715 0 5.459 5.459 0 0 1 0 7.714 5.446 5.446 0 0 1-6.203 1.06l-2.797 2.797L11 18.737 8.428 21.31l-2.571-2.571-1.286 1.286L2 17.452 8.653 10.8zm6.24-1.044a1.824 1.824 0 0 0 0-2.571 1.824 1.824 0 0 0-2.571 0 1.824 1.824 0 0 0 0 2.57 1.824 1.824 0 0 0 2.57 0zM0 8h3v3H0V8zm0-8h3v6H0V0z"
  })));
}

IconKeyAttention.propTypes = propTypes$10;
IconKeyAttention.defaultProps = defaultProps$10;

var propTypes$11 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$11 = {
  size: 24,
  color: 'secondary',
  title: 'Key not available icon'
};

function IconKeyNotAvailable(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "-2 -2 24 24"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.562 9.89l2.571 2.572-1.705 1.705L10 16.737 7.428 19.31l-2.571-2.571-1.286 1.286L1 15.452 6.562 9.89zm7.473 1.817L7.317 4.989a5.418 5.418 0 0 1 1.397-2.393 5.459 5.459 0 0 1 7.714 0 5.459 5.459 0 0 1 0 7.714 5.418 5.418 0 0 1-2.393 1.397zm-.142-3.951a1.824 1.824 0 0 0 0-2.571 1.824 1.824 0 0 0-2.571 0 1.824 1.824 0 0 0 0 2.57 1.824 1.824 0 0 0 2.57 0zM1.368.454l17.678 17.678-1.414 1.414L-.046 1.868 1.368.454z"
  })));
}

IconKeyNotAvailable.propTypes = propTypes$11;
IconKeyNotAvailable.defaultProps = defaultProps$11;

var propTypes$12 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$12 = {
  size: 24,
  color: 'secondary',
  title: 'Key pick icon'
};

function IconKeyPickUp(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "-1 -2 24 24",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 10.5602l6.65323 6.65323-2.5713 2.5713-1.28565-1.28565-2.5713 2.5713-2.5713-2.5713 2.5713-2.5713L7.8002 13.1315c-2.0249.97066-4.52548.61711-6.20325-1.06066-2.12775-2.12775-2.12775-5.58615 0-7.7139 2.12774-2.12774 5.58614-2.12774 7.71389 0 1.67777 1.67778 2.03132 4.17836 1.06066 6.20326zM4.13188 9.51698c.7071.7071 1.86419.7071 2.5713 0 .7071-.7071.7071-1.86419 0-2.5713-.70711-.7071-1.8642-.7071-2.5713 0-.7071.70711-.7071 1.8642 0 2.5713zM11.1214 2l7 1 1 7 1.94859-2V.05141h-7.9486L11.1214 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconKeyPickUp.propTypes = propTypes$12;
IconKeyPickUp.defaultProps = defaultProps$12;

var propTypes$13 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$13 = {
  size: 24,
  color: 'secondary',
  title: 'Key return icon'
};

function IconKeyReturn(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "-1 -2 24 24",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5598 10.70986l6.65324-6.65323 2.5713 2.5713-1.28565 1.28564 2.5713 2.5713-2.5713 2.5713-2.5713-2.5713-2.79628 2.79629c.97066 2.0249.6171 4.52548-1.06066 6.20325-2.12775 2.12775-5.58615 2.12775-7.7139 0s-2.12775-5.58614 0-7.7139c1.67777-1.67776 4.17836-2.03132 6.20326-1.06065zM9.5166 16.94948c.7071-.7071.7071-1.8642 0-2.5713-.7071-.7071-1.8642-.7071-2.5713 0-.7071.7071-.7071 1.8642 0 2.5713.7071.7071 1.8642.7071 2.5713 0zM10 2L3 3l-1 7L.05141 8V.05141H8L10 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconKeyReturn.propTypes = propTypes$13;
IconKeyReturn.defaultProps = defaultProps$13;

var propTypes$14 = {
  size: PropTypes.number,
  title: PropTypes.string
};
var defaultProps$14 = {
  size: 24,
  title: 'Klarna logo'
};

function IconKlarna(_ref) {
  var size = _ref.size,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["size", "title"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    id: "karna",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Icon.G, {
    id: "klarna-k"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#F4B6C7",
    fillRule: "nonzero",
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    rx: "12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7000091,15.7501091 C15.7000091,16.5783818 16.3716273,17.25 17.2000909,17.25 C18.0283636,17.25 18.7000091,16.5783818 18.7000091,15.7501091 C18.7000091,14.9216182 18.0283636,14.25 17.2000909,14.25 C16.3716273,14.25 15.7000091,14.9216182 15.7000091,15.7501091 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95000909,17.25 L6.70000909,17.25 L6.70000909,6.75 L8.95000909,6.75 L8.95000909,17.25 Z M9.36681818,12.0222818 C11.3631273,11.0390727 12.6535091,9.05241818 12.7000091,6.75092727 L15.0632455,6.75092727 C15.0312,8.93618182 14.1293182,10.9634182 12.5415818,12.4672636 L15.7000091,17.25 L12.7000091,17.25 L9.36681818,12.0222818 Z",
    id: "Shape",
    fill: "#000000"
  }))));
}

IconKlarna.propTypes = propTypes$14;
IconKlarna.defaultProps = defaultProps$14;

var propTypes$15 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$15 = {
  size: 24,
  color: 'secondary',
  title: 'Cleaning supplies by Freska'
};

function IconLiquids(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
  })));
}

IconLiquids.propTypes = propTypes$15;
IconLiquids.defaultProps = defaultProps$15;

var propTypes$16 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$16 = {
  size: 24,
  color: 'secondary',
  title: 'Sick leave icon'
};

function IconLocalHospital(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.778 2H4.222a2.22 2.22 0 00-2.21 2.222L2 19.778C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2zm-1.111 12.222h-4.445v4.445H9.778v-4.445H5.333V9.778h4.445V5.333h4.444v4.445h4.445v4.444z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconLocalHospital.propTypes = propTypes$16;
IconLocalHospital.defaultProps = defaultProps$16;

var propTypes$17 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$17 = {
  size: 24,
  color: 'secondary',
  title: 'Location icon'
};

function IconLocation(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
  })));
}

IconLocation.propTypes = propTypes$17;
IconLocation.defaultProps = defaultProps$17;

var propTypes$18 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$18 = {
  size: 24,
  color: 'secondary',
  title: 'Tag icon'
};

function IconLock(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "-4 -1 24 24",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7h-1V5c0-2.76-2.24-5-5-5S3 2.24 3 5v2H2C.9 7 0 7.9 0 9v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H4.9V5c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
  })));
}

IconLock.propTypes = propTypes$18;
IconLock.defaultProps = defaultProps$18;

var propTypes$19 = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$19 = {
  size: 24,
  color: 'secondary',
  title: 'Directions icon'
};

function IconMenu(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  })));
}

IconMenu.propTypes = propTypes$19;
IconMenu.defaultProps = defaultProps$19;

var propTypes$1a = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1a = {
  size: 24,
  color: 'secondary',
  title: 'More menu icon'
};

function IconMoreVertical(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconMoreVertical.propTypes = propTypes$1a;
IconMoreVertical.defaultProps = defaultProps$1a;

var propTypes$1b = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1b = {
  size: 24,
  color: 'secondary',
  title: 'Moving icon'
};

function IconMoving(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,8 L17,8 L17,4 L3,4 C1.9,4 1,4.9 1,6 L1,17 L3,17 C3,18.66 4.34,20 6,20 C7.66,20 9,18.66 9,17 L15,17 C15,18.66 16.34,20 18,20 C19.66,20 21,18.66 21,17 L23,17 L23,12 L20,8 Z M6,18.5 C5.17,18.5 4.5,17.83 4.5,17 C4.5,16.17 5.17,15.5 6,15.5 C6.83,15.5 7.5,16.17 7.5,17 C7.5,17.83 6.83,18.5 6,18.5 Z M19.5,9.5 L21.46,12 L17,12 L17,9.5 L19.5,9.5 Z M18,18.5 C17.17,18.5 16.5,17.83 16.5,17 C16.5,16.17 17.17,15.5 18,15.5 C18.83,15.5 19.5,16.17 19.5,17 C19.5,17.83 18.83,18.5 18,18.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconMoving.propTypes = propTypes$1b;
IconMoving.defaultProps = defaultProps$1b;

var propTypes$1c = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1c = {
  size: 24,
  color: 'secondary',
  title: 'Tag icon'
};

function IconNextBooking(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconNextBooking.propTypes = propTypes$1c;
IconNextBooking.defaultProps = defaultProps$1c;

var propTypes$1d = {
  size: PropTypes.number,
  title: PropTypes.string
};
var defaultProps$1d = {
  size: 24,
  title: 'Norwegian reward icon'
};

function IconNorwegianReward(_ref) {
  var size = _ref.size,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["size", "title"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "0 0 56 56"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React.createElement(Icon.G, {
    id: "element/icon/reward-program/norwegian",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D81939",
    cx: "28",
    cy: "28",
    r: "28"
  }), /*#__PURE__*/React.createElement(Icon.G, {
    id: "norwegian-n+plane",
    transform: "translate(10.000000, 12.000000)",
    "fill-rule": "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.35,1.23101781 L12.25,1.23101781 L12.25,4.23101781 C18.05,-0.968982193 25.65,-0.968982193 30.45,2.03101781 C35.65,5.23101781 35.65,10.2310178 35.65,16.0310178 L35.65,32.7310178 L23.85,32.7310178 L23.85,19.4310178 C23.85,16.4310178 24.05,12.5310178 21.05,10.4310178 C19.75,9.33101781 16.95,9.33101781 15.25,10.6310178 C12.25,12.8310178 12.65,15.4310178 12.65,19.9310178 L12.65,32.4310178 L0.45,32.4310178 L0.45,1.23101781 L0.35,1.23101781 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.95,7.23101781 C31.65,7.23101781 32.25,7.43101781 32.85,7.43101781 C33.15,7.63101781 33.35,7.63101781 33.75,7.83101781 C33.95,7.83101781 33.95,8.03101781 34.15,8.03101781 C34.35,8.23101781 34.25,8.23101781 34.35,8.43101781 C34.55,8.93101781 34.15,9.33101781 33.95,9.73101781 C33.25,11.0310178 31.85,12.0310178 30.65,12.9310178 C29.35,14.0310178 28.05,14.8310178 26.65,15.7310178 C26.45,15.9310178 26.15,16.1310178 25.95,16.2310178 C26.15,16.4310178 26.35,16.4310178 26.65,16.4310178 L26.85,16.6310178 C27.25,16.4310178 27.55,16.2310178 27.95,16.1310178 C28.35,15.9310178 28.65,15.9310178 29.05,15.9310178 C29.25,16.1310178 29.75,16.4310178 29.75,16.6310178 C29.95,17.1310178 29.95,17.5310178 29.55,18.1310178 C31.25,18.8310178 32.85,19.8310178 34.55,20.5310178 C34.95,20.7310178 35.25,20.9310178 35.75,21.2310178 C35.95,21.4310178 35.55,21.7310178 35.35,21.9310178 C34.65,22.1310178 34.15,22.6310178 33.45,22.6310178 C32.75,22.4310178 32.15,22.4310178 31.35,22.1310178 C30.25,21.9310178 29.25,21.6310178 28.15,21.4310178 C27.45,21.2310178 26.45,21.2310178 25.55,20.9310178 C24.85,20.7310178 24.35,20.7310178 23.65,20.7310178 C22.95,20.5310178 21.95,20.5310178 21.05,20.5310178 C19.95,20.5310178 19.05,20.5310178 17.95,20.3310178 C16.25,21.0310178 14.85,21.8310178 12.95,22.4310178 C11.75,22.8310178 10.65,23.1310178 9.45,23.6310178 C9.85,24.1310178 10.35,24.3310178 10.65,24.9310178 C10.65,25.1310178 10.45,25.1310178 10.45,25.1310178 C10.25,25.3310178 10.05,25.3310178 9.75,25.3310178 C8.55,25.1310178 7.45,24.8310178 6.25,24.4310178 C5.75,24.6310178 4.95,25.1310178 4.35,24.4310178 C4.35,24.2310178 4.15,24.2310178 4.15,23.9310178 C4.25,23.8310178 4.05,23.8310178 3.95,23.7310178 C3.75,23.5310178 3.55,23.5310178 3.45,23.5310178 C3.05,23.3310178 2.75,23.3310178 2.25,23.0310178 C1.55,22.8310178 0.75,22.6310178 0.15,22.3310178 C-0.05,22.1310178 -0.05,22.1310178 0.15,21.8310178 C0.55,21.6310178 1.25,21.3310178 1.85,21.6310178 C2.35,21.6310178 3.05,21.8310178 3.55,21.8310178 C2.85,21.1310178 2.35,20.5310178 1.65,19.8310178 C1.45,19.6310178 1.45,19.6310178 1.45,19.3310178 C1.45,19.1310178 1.65,19.1310178 1.65,18.9310178 C1.85,18.7310178 1.85,18.7310178 2.05,18.7310178 C2.55,18.5310178 2.75,18.3310178 3.15,18.5310178 C4.35,19.0310178 5.25,19.4310178 6.65,20.0310178 C6.85,20.2310178 7.15,20.2310178 7.35,20.2310178 C7.75,20.0310178 7.85,20.0310178 8.05,19.8310178 C8.25,19.8310178 8.55,19.6310178 8.75,19.4310178 C9.15,19.2310178 9.45,18.9310178 9.85,18.7310178 C10.55,18.2310178 11.05,18.0310178 11.75,17.5310178 C10.85,17.1310178 9.75,16.6310178 8.85,16.2310178 C7.75,16.0310178 7.55,15.8310178 6.55,15.5310178 C5.85,15.3310178 5.05,15.1310178 5.05,15.1310178 C3.75,14.9310178 3.35,14.7310178 2.25,14.4310178 C1.95,13.9310178 1.25,13.9310178 0.55,13.7310178 L0.55,13.5310178 L1.25,12.8310178 C1.65,12.6310178 1.95,12.3310178 2.45,12.1310178 C3.35,12.1310178 4.15,12.3310178 5.05,12.3310178 C6.25,12.5310178 7.45,12.5310178 8.55,12.7310178 C10.05,12.9310178 11.75,12.9310178 13.25,13.2310178 C13.45,13.2310178 13.45,13.4310178 13.65,13.2310178 C13.85,13.4310178 13.85,13.2310178 14.05,13.4310178 L14.45,13.4310178 C15.15,12.9310178 15.95,12.2310178 16.85,11.9310178 C17.35,11.9310178 17.95,12.1310178 18.15,12.6310178 C19.85,11.4310178 21.45,10.2310178 23.35,9.33101781 C25.05,8.43101781 26.65,7.63101781 28.05,7.33101781 C28.95,7.13101781 30.05,6.93101781 30.95,6.83101781 C30.45,7.23101781 30.65,7.23101781 30.95,7.23101781",
    id: "Path",
    fill: "#003D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85,8.33101781 C31.15,8.53101781 30.55,8.53101781 29.55,9.03101781 C28.85,9.23101781 27.55,9.73101781 26.45,10.3310178 C24.95,11.0310178 23.85,11.8310178 22.15,12.7310178 C21.65,13.1310178 20.45,14.0310178 20.25,14.2310178 C19.35,14.0310178 18.55,14.0310178 17.65,14.0310178 L17.85,13.8310178 C19.05,12.9310178 19.95,12.1310178 21.35,11.5310178 C22.35,10.8310178 24.05,9.83101781 25.35,9.43101781 C26.55,8.93101781 27.95,8.53101781 29.15,8.33101781 C30.25,7.93101781 31.15,7.93101781 31.85,8.33101781 M14.65,14.1310178 C14.85,13.9310178 15.05,13.9310178 15.35,13.7310178 C15.55,13.5310178 15.75,13.5310178 15.85,13.5310178 C15.65,13.9310178 15.65,14.0310178 15.85,14.4310178 C15.85,14.6310178 16.05,14.8310178 16.05,14.9310178 C15.55,15.3310178 14.95,15.6310178 14.35,16.0310178 C14.15,15.8310178 14.15,15.8310178 14.15,15.5310178 C13.95,15.1310178 14.15,14.8310178 14.35,14.4310178 L14.65,14.1310178 Z M13.65,18.5310178 C12.95,18.9310178 12.35,19.2310178 11.65,19.6310178 C10.35,20.3310178 8.85,21.1310178 6.85,22.0310178 C6.35,22.2310178 5.75,22.4310178 5.15,22.2310178 C4.75,22.2310178 4.75,22.2310178 4.45,22.0310178 L2.35,19.9310178 C2.15,19.7310178 2.15,19.7310178 2.15,19.5310178 L2.45,19.3310178 L2.65,19.3310178 C3.75,19.7310178 4.35,20.0310178 5.45,20.6310178 C5.85,20.8310178 6.15,21.0310178 6.65,21.1310178 C7.05,21.1310178 7.35,20.9310178 7.85,20.9310178 L8.05,20.7310178 C8.55,20.3310178 8.75,20.2310178 9.15,20.0310178 C10.25,19.3310178 11.15,18.8310178 12.25,18.1310178 L12.45,17.9310178 C12.85,18.3310178 13.15,18.4310178 13.65,18.5310178",
    id: "Shape",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconNorwegianReward.propTypes = propTypes$1d;
IconNorwegianReward.defaultProps = defaultProps$1d;

var propTypes$1e = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1e = {
  size: 24,
  color: 'secondary',
  title: 'Note icon'
};

function IconNote(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconNote.propTypes = propTypes$1e;
IconNote.defaultProps = defaultProps$1e;

var propTypes$1f = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1f = {
  size: 24,
  color: 'secondary',
  title: 'Directions icon'
};

function IconOffice(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "0 0 48 48",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14V6H4v36h40V14H24zM12 38H8v-4h4v4zm0-8H8v-4h4v4zm0-8H8v-4h4v4zm0-8H8v-4h4v4zm8 24h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm20 24H24v-4h4v-4h-4v-4h4v-4h-4v-4h16v20zm-4-16h-4v4h4v-4zm0 8h-4v4h4v-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z",
    fill: "none"
  }));
}

IconOffice.propTypes = propTypes$1f;
IconOffice.defaultProps = defaultProps$1f;

var propTypes$1g = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1g = {
  size: 24,
  color: 'secondary',
  title: 'One-off'
};

function IconOneOff(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2 L18,2 C20.209139,2 22,3.790861 22,6 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 Z M6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,6 C20,4.8954305 19.1045695,4 18,4 L6,4 Z M11.5,17 L11.5,9 L9.5,10 L9.5,8 L11.5,7 L13.5,7 L13.5,17 L11.5,17 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconOneOff.propTypes = propTypes$1g;
IconOneOff.defaultProps = defaultProps$1g;

var propTypes$1h = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1h = {
  size: 24,
  color: 'secondary',
  title: 'Other absence icon'
};

function IconOtherAbsence(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h16zM2.188 19.11c-.125.437-.188.687-.188.687l1.25.25c0-.062.062-.25.125-.625zm19.75.062l-1.25.25c.062.312.062.5.062.5H22c0-.062 0-.312-.063-.75zm-1.126-2.625l-1 .75c.188.313.375.625.5 1l1.188-.5a8.011 8.011 0 00-.688-1.25zm-17.5.062c-.25.376-.5.75-.687 1.25l1.125.438a2.36 2.36 0 01.562-.938zm15.25-1.75L18 15.986c.375.25.75.437 1 .625l.75-1.063c-.312-.25-.75-.437-1.187-.687zm-13 .063c-.437.25-.875.438-1.187.688l.688 1c.25-.188.625-.376 1.062-.563zm10.563-1l-.437 1.188c.437.125.812.312 1.187.437l.5-1.187c-.438-.125-.813-.313-1.25-.438zM8 13.86c-.437.125-.875.25-1.25.437l.438 1.188a6.7 6.7 0 001.187-.438zm2-.75l-.375 1.625.563-.188.625-.187v-.626l-.438-.312c-.125-.062-.25-.187-.375-.312zm4.188 0c-.125.125-.25.25-.375.312l-.563.375v.563l.75.187.563.188-.375-1.625zm1.062-1.813a4.84 4.84 0 01-.437 1l1.062.625c.188-.375.375-.812.562-1.25zm-6.312-.063l-1.188.375c.125.438.313.876.5 1.25l1.125-.625a4.847 4.847 0 01-.437-1zM16.75 9.11H15.5c0 .375 0 .75-.063 1.125l1.25.187c.063-.437.125-.875.063-1.312zm-9.375-.063v.063c0 .437 0 .875.062 1.25l1.25-.188c-.062-.312-.062-.687-.062-1.062l-1.25-.063zM16 6.547l-1.062.625c.187.313.312.625.437.938l1.188-.313A4.507 4.507 0 0016 6.547zm-7.875-.125a4.51 4.51 0 00-.563 1.25l1.188.375c.125-.313.25-.625.437-1zm5.938-1.813l-.626 1.063c.313.125.563.375.813.625l.938-.875c-.313-.313-.688-.625-1.125-.813zM10 4.61c-.375.188-.75.5-1.063.813l.875.875c.25-.25.563-.5.813-.625zm2.812-.562a5.531 5.531 0 00-1.437 0l.25 1.25c.312-.063.625-.063.938 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconOtherAbsence.propTypes = propTypes$1h;
IconOtherAbsence.defaultProps = defaultProps$1h;

var propTypes$1i = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1i = {
  size: 24,
  color: 'secondary',
  title: 'Pets icon'
};

function IconPets(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "9.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "5.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "19.5",
    cy: "9.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconPets.propTypes = propTypes$1i;
IconPets.defaultProps = defaultProps$1i;

var propTypes$1j = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1j = {
  size: 24,
  color: 'secondary',
  title: 'Pinned icon'
};

function IconPin(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "0 0 15 15",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62132 10.62132l4.24264-4.24264.53033.53033 1.06066-1.06066-5.3033-5.3033L8.09099 1.6057l.53033.53033-4.24264 4.24264H2.25736L1.1967 7.43934l2.75772 2.75772-3.18198 3.18198.84852.84852 3.18198-3.18198 2.75772 2.75772 1.06066-1.06066z"
  })));
}

IconPin.propTypes = propTypes$1j;
IconPin.defaultProps = defaultProps$1j;

var propTypes$1k = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1k = {
  size: 24,
  color: 'secondary',
  title: 'Key icon'
};

function IconPolygon(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "0 0 20 19"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0l9.51 6.91-3.632 11.18H4.122L.49 6.91z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-3h24v24H-2z"
  }));
}

IconPolygon.propTypes = propTypes$1k;
IconPolygon.defaultProps = defaultProps$1k;

var propTypes$1l = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1l = {
  size: 24,
  color: 'secondary',
  title: 'Receipt icon'
};

function IconReceipt(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
  })));
}

IconReceipt.propTypes = propTypes$1l;
IconReceipt.defaultProps = defaultProps$1l;

var propTypes$1m = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1m = {
  size: 24,
  color: 'secondary',
  title: 'Recurring icon'
};

function IconRecurring(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconRecurring.propTypes = propTypes$1m;
IconRecurring.defaultProps = defaultProps$1m;

var propTypes$1n = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1n = {
  size: 24,
  color: 'secondary',
  title: 'Recurring icon'
};

function IconRecurringInstanceOf(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "-2 -2 24 24",
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm10.942 5.056A6.993 6.993 0 0 0 3 10c0 3.867 3.126 7 6.996 7 3.265 0 5.988-2.231 6.768-5.25h-1.822a5.245 5.245 0 0 1-4.946 3.5A5.256 5.256 0 0 1 4.742 10a5.256 5.256 0 0 1 5.254-5.25 5.18 5.18 0 0 1 3.694 1.557l-2.819 2.818H17V3l-2.058 2.056z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconRecurringInstanceOf.propTypes = propTypes$1n;
IconRecurringInstanceOf.defaultProps = defaultProps$1n;

var propTypes$1o = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1o = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconRefund(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconRefund.propTypes = propTypes$1o;
IconRefund.defaultProps = defaultProps$1o;

var propTypes$1p = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1p = {
  size: 24,
  color: 'secondary',
  title: 'Reschedule icon'
};

function IconReschedule(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 0 1 9 9h3l-3.89 3.89-.07.14L16 12h3c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.93 0 3.68-.79 4.94-2.06l1.42 1.42A8.954 8.954 0 0 1 12 21a9 9 0 0 1 0-18zm-1.1 5v5l4.28 2.54.72-1.21-3.5-2.08V8h-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconReschedule.propTypes = propTypes$1p;
IconReschedule.defaultProps = defaultProps$1p;

var propTypes$1q = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1q = {
  size: 24,
  color: 'secondary',
  title: 'Search icon'
};

function IconSearch(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconSearch.propTypes = propTypes$1q;
IconSearch.defaultProps = defaultProps$1q;

var propTypes$1r = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1r = {
  size: 24,
  color: 'rating',
  title: 'Star icon'
};

function IconStarFull(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "0 0 48 48",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 38.58442L38.832 48l-3.924-17.75747L48 18.30063 30.7416 16.7419 24 0l-6.7416 16.7419L0 18.30062l13.092 11.9419L9.168 48z"
  })));
}

IconStarFull.propTypes = propTypes$1r;
IconStarFull.defaultProps = defaultProps$1r;

var propTypes$1s = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1s = {
  size: 24,
  color: 'greyMed',
  title: 'Star empty icon'
};

function IconStarOutline(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "0 0 48 48",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 18.30063L30.7416 16.7419 24 0l-6.7416 16.7419L0 18.30062l13.092 11.9419L9.168 48 24 38.5819 38.832 48l-3.924-17.75747L48 18.30063zm-24 15.5419l-9.0312 5.73473 2.3904-10.81515-7.9752-7.27074 10.512-.9499L24 10.34527l4.104 10.1962 10.512.9499-7.9728 7.27074 2.3904 10.81515L24 33.84253z"
  })));
}

IconStarOutline.propTypes = propTypes$1s;
IconStarOutline.defaultProps = defaultProps$1s;

function _templateObject2$m() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var propTypes$1t = {
  size: PropTypes.number,
  color: PropTypes.string,
  outlineColor: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1t = {
  size: 24,
  color: 'rating',
  outlineColor: 'greyMed',
  title: 'Half star icon'
};

function IconStarHalf(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      outlineColor = _ref.outlineColor,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color", "outlineColor"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "0 0 48 48",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, null, /*#__PURE__*/React.createElement(HalfStar, {
    color: color,
    d: "M24 0l-6.7416 16.7419L0 18.30062l13.092 11.9419L9.168 48 24 38.5819z"
  }), /*#__PURE__*/React.createElement(OutlineStar, {
    d: "M24 33.8443l9.0336 5.73505-2.3904-10.81573 7.9728-7.27112-10.512-.94995L24 10.34581V0l6.7416 16.74278L48 18.30159l-13.092 11.94L38.832 48 24 38.58393V33.8443z",
    outlineColor: outlineColor
  })));
}

var HalfStar = styled.path(_templateObject$w(), function (props) {
  return props.theme.colors[props.color];
});
var OutlineStar = styled.path(_templateObject2$m(), function (props) {
  return props.theme.colors[props.outlineColor];
});
IconStarHalf.propTypes = propTypes$1t;
IconStarHalf.defaultProps = defaultProps$1t;

var propTypes$1u = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1u = {
  size: 24,
  color: 'secondary',
  title: 'RUT claims'
};

function IconSwedishTaxAuthority(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,19 C20.33,19 21,19.67 21,20.5 C21,21.33 20.33,22 19.5,22 L19.5,22 L3.5,22 C2.67,22 2,21.33 2,20.5 C2,19.67 2.67,19 3.5,19 L3.5,19 Z M5.47607422,9.96923828 C5.93082682,9.96923828 6.32291667,10.0444336 6.65234375,10.1948242 C6.98177083,10.3452148 7.296875,10.5779622 7.59765625,10.8930664 L7.59765625,10.8930664 L6.97998047,11.7524414 L6.97460938,11.7631836 L6.97058105,11.7618408 L6.96923828,11.7578125 L6.86267578,11.6053809 C6.71314453,11.4137402 6.53382161,11.2685059 6.32470703,11.1696777 C6.0633138,11.0461426 5.77685547,10.984375 5.46533203,10.984375 C5.2648112,10.984375 5.09204102,11.0192871 4.94702148,11.0891113 C4.80200195,11.1589355 4.69278971,11.2511393 4.61938477,11.3657227 C4.54597982,11.480306 4.50927734,11.6056315 4.50927734,11.7416992 C4.50927734,11.902832 4.55135091,12.045166 4.63549805,12.1687012 C4.71964518,12.2922363 4.86376953,12.4193522 5.06787109,12.5500488 C5.27197266,12.6807454 5.56917318,12.8409831 5.95947266,13.0307617 C6.42496745,13.2527669 6.78662109,13.4667155 7.04443359,13.6726074 C7.30224609,13.8784993 7.48486328,14.0942383 7.59228516,14.3198242 C7.69970703,14.5454102 7.75341797,14.8085938 7.75341797,15.109375 C7.75341797,15.4746094 7.66927083,15.8156738 7.50097656,16.1325684 C7.33268229,16.4494629 7.06681315,16.7063802 6.70336914,16.9033203 C6.33992513,17.1002604 5.87890625,17.1987305 5.3203125,17.1987305 C4.42871094,17.1987305 3.65527344,16.8800456 3,16.2426758 L3,16.2426758 L3.53710938,15.3081055 L3.54248047,15.2973633 L3.55322266,15.3081055 L3.70094993,15.4525923 C4.20077237,15.9112808 4.77457682,16.140625 5.42236328,16.140625 C5.76611328,16.140625 6.03198242,16.0600586 6.2199707,15.8989258 C6.40795898,15.737793 6.50195312,15.4960938 6.50195312,15.1738281 C6.50195312,15.0126953 6.46166992,14.8667806 6.38110352,14.736084 C6.30053711,14.6053874 6.16267904,14.4737956 5.9675293,14.3413086 C5.77237956,14.2088216 5.50292969,14.0655924 5.15917969,13.9116211 C4.5218099,13.6359049 4.05989583,13.3261719 3.7734375,12.9824219 C3.48697917,12.6386719 3.34375,12.2394206 3.34375,11.784668 C3.34375,11.4552409 3.43595378,11.1517741 3.62036133,10.8742676 C3.80476888,10.5967611 4.05900065,10.3765462 4.38305664,10.213623 C4.70711263,10.0506999 5.07145182,9.96923828 5.47607422,9.96923828 Z M18.6986328,10.0605469 L18.8835999,10.0981445 C19.0601746,10.1303711 19.2115723,10.1464844 19.337793,10.1464844 L19.337793,10.1464844 L20.0951172,10.1464844 L17.5438477,13.0629883 L20.1917969,16.9892578 L18.6986328,17.0537109 L16.6629883,13.8740234 L16.3675781,14.1962891 L16.3675781,17 L15.1,17 L15.1,10.1464844 L16.4535156,10.1464844 L16.4535156,10.2700195 L16.4189019,10.3144803 C16.399009,10.3451154 16.3854818,10.3777398 16.3783203,10.4123535 C16.3675781,10.4642741 16.3639974,10.5511068 16.3675781,10.6728516 L16.3675781,10.6728516 L16.3675781,12.7675781 L18.6986328,10.0605469 Z M13.7633789,10.1464844 L13.7633789,11.2045898 L10.4977539,11.2045898 L10.4977539,12.8964844 L13.2047852,12.8964844 L13.2047852,13.9760742 L10.4977539,13.9760742 L10.4977539,15.9418945 L13.7418945,15.9418945 L13.7418945,17 L9.3,17 L9.3,10.1464844 L13.7633789,10.1464844 Z M10.57,1.49 L2.67,5.65 C2.26,5.86 2,6.29 2,6.75 C2,7.44 2.56,8 3.25,8 L19.76,8 C20.44,8 21,7.44 21,6.75 C21,6.29 20.74,5.86 20.33,5.65 L12.43,1.49 C11.85,1.18 11.15,1.18 10.57,1.49 Z"
  })));
}

IconSwedishTaxAuthority.propTypes = propTypes$1u;
IconSwedishTaxAuthority.defaultProps = defaultProps$1u;

var propTypes$1v = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1v = {
  size: 24,
  color: 'secondary',
  title: 'Tag icon'
};

function IconTag(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconTag.propTypes = propTypes$1v;
IconTag.defaultProps = defaultProps$1v;

var propTypes$1w = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1w = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconTransferWithinAStation(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconTransferWithinAStation.propTypes = propTypes$1w;
IconTransferWithinAStation.defaultProps = defaultProps$1w;

var propTypes$1x = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1x = {
  size: 24,
  color: 'secondary',
  title: 'Key icon'
};

function IconTrending(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title,
    viewBox: "0 0 20 12"
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0l2.29 2.29-2.263 2.263L11.41 7.17l-4-4L0 10.59 1.41 12l6-6 4 4 6.3-6.29L20 6V0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-3h24v24H-2z"
  }));
}

IconTrending.propTypes = propTypes$1x;
IconTrending.defaultProps = defaultProps$1x;

var propTypes$1y = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1y = {
  size: 24,
  color: 'secondary',
  title: 'Warning'
};

function IconWarning(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  })));
}

IconWarning.propTypes = propTypes$1y;
IconWarning.defaultProps = defaultProps$1y;

var propTypes$1z = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1z = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconGear(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconGear.propTypes = propTypes$1z;
IconGear.defaultProps = defaultProps$1z;

var propTypes$1A = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1A = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconGift(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconGift.propTypes = propTypes$1A;
IconGift.defaultProps = defaultProps$1A;

var propTypes$1B = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1B = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconGlobe(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconGlobe.propTypes = propTypes$1B;
IconGlobe.defaultProps = defaultProps$1B;

var propTypes$1C = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1C = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconGroup(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconGroup.propTypes = propTypes$1C;
IconGroup.defaultProps = defaultProps$1C;

var propTypes$1D = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1D = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconGroupOutline(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconGroupOutline.propTypes = propTypes$1D;
IconGroupOutline.defaultProps = defaultProps$1D;

var propTypes$1E = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1E = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconMap(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconMap.propTypes = propTypes$1E;
IconMap.defaultProps = defaultProps$1E;

var propTypes$1F = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1F = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconPerson(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconPerson.propTypes = propTypes$1F;
IconPerson.defaultProps = defaultProps$1F;

var propTypes$1G = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1G = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconPersonOutline(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconPersonOutline.propTypes = propTypes$1G;
IconPersonOutline.defaultProps = defaultProps$1G;

var propTypes$1H = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1H = {
  size: 24,
  color: 'secondary',
  title: 'Add icon'
};

function IconWindow(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    viewBox: "-2 -0.5 24 24",
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    stroke: color,
    fillRule: "nonzero",
    strokeWidth: "2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 17.92h17.394M4.207 21.8H15.05M9.834 1v16.56M3.397 9.46h12.268M3.046 17.56V1h13.301v16.56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconWindow.propTypes = propTypes$1H;
IconWindow.defaultProps = defaultProps$1H;

var propTypes$1I = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string
};
var defaultProps$1I = {
  size: 24,
  color: 'secondary',
  title: 'Zendesk'
};

function IconZendesk(_ref) {
  var size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "title", "color"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: size,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Icon.G, {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.919 9.431V19H3l7.919-9.569zm0-3.431a3.971 3.971 0 01-3.96 3.96A3.971 3.971 0 013 6h7.919zm1.32 13a3.971 3.971 0 013.959-3.96 3.971 3.971 0 013.96 3.96h-7.92zm0-3.431V6h7.918l-7.918 9.569z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

IconZendesk.propTypes = propTypes$1I;
IconZendesk.defaultProps = defaultProps$1I;

export { Accordion, Box, Button, Card, Checkbox, Consent, Heading, IconAdd, IconAddCircle, IconArrowBack, IconArrowForward, IconAssignment, IconAt, IconAttachment, IconBeachAccess, IconBraintree, IconButton, IconCalendarEvent, IconCall, IconCancel, IconCheck, IconCheckCircle, IconChevronLeft, IconChevronRight, IconClose, IconClosingDay, IconComment, IconDateRange, IconDirections, IconDrawerHandle, IconEdit, IconEmail, IconErrorOutline, IconExpandLess, IconExpandMore, IconFeedback, IconGear, IconGift, IconGlobe, IconGroup, IconGroupOutline, IconHealing, IconHelpOutline, IconHome, IconKey, IconKeyAttention, IconKeyNotAvailable, IconKeyPickUp, IconKeyReturn, IconKlarna, IconLiquids, IconLocalHospital, IconLocation, IconLock, IconMap, IconMenu, IconMoreVertical, IconMoving, IconNextBooking, IconNorwegianReward, IconNote, IconOffice, IconOneOff, IconOtherAbsence, IconPerson, IconPersonOutline, IconPets, IconPin, IconPolygon, IconReceipt, IconRecurring, IconRecurringInstanceOf, IconRefund, IconRemove, IconReschedule, IconSearch, IconStarFull, IconStarHalf, IconStarOutline, IconSwedishTaxAuthority, IconTag, IconTransferWithinAStation, IconTrending, IconWarning, IconWindow, IconZendesk, Input$2 as Input, Label$4 as Label, Link, List, Logo$1 as Logo, LogoIcon, Modal$1 as Modal, Provider, RadioBox, RadioButton, Select, Spinner, Stepper, Tag, Text, TextArea, theme, typography };
